/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
if (typeof lazySizes !== "function" && typeof lazySizes !== "object") {
  /*! lazysizes - v4.1.8 */
  !(function (a, b) {
    var c = b(a, a.document);
    (a.lazySizes = c),
      "object" == typeof module && module.exports && (module.exports = c);
  })(window, function (a, b) {
    "use strict";
    if (b.getElementsByClassName) {
      var c,
        d,
        e = b.documentElement,
        f = a.Date,
        g = a.HTMLPictureElement,
        h = "addEventListener",
        i = "getAttribute",
        j = a[h],
        k = a.setTimeout,
        l = a.requestAnimationFrame || k,
        m = a.requestIdleCallback,
        n = /^picture$/i,
        o = ["load", "error", "lazyincluded", "_lazyloaded"],
        p = {},
        q = Array.prototype.forEach,
        r = function (a, b) {
          return (
            p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")),
            p[b].test(a[i]("class") || "") && p[b]
          );
        },
        s = function (a, b) {
          r(a, b) ||
            a.setAttribute("class", (a[i]("class") || "").trim() + " " + b);
        },
        t = function (a, b) {
          var c;
          (c = r(a, b)) &&
            a.setAttribute("class", (a[i]("class") || "").replace(c, " "));
        },
        u = function (a, b, c) {
          var d = c ? h : "removeEventListener";
          c && u(a, b),
            o.forEach(function (c) {
              a[d](c, b);
            });
        },
        v = function (a, d, e, f, g) {
          var h = b.createEvent("Event");
          return (
            e || (e = {}),
            (e.instance = c),
            h.initEvent(d, !f, !g),
            (h.detail = e),
            a.dispatchEvent(h),
            h
          );
        },
        w = function (b, c) {
          var e;
          !g && (e = a.picturefill || d.pf)
            ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src),
              e({ reevaluate: !0, elements: [b] }))
            : c && c.src && (b.src = c.src);
        },
        x = function (a, b) {
          return (getComputedStyle(a, null) || {})[b];
        },
        y = function (a, b, c) {
          for (
            c = c || a.offsetWidth;
            c < d.minSize && b && !a._lazysizesWidth;

          )
            (c = b.offsetWidth), (b = b.parentNode);
          return c;
        },
        z = (function () {
          var a,
            c,
            d = [],
            e = [],
            f = d,
            g = function () {
              var b = f;
              for (f = d.length ? e : d, a = !0, c = !1; b.length;)
                b.shift()();
              a = !1;
            },
            h = function (d, e) {
              a && !e
                ? d.apply(this, arguments)
                : (f.push(d), c || ((c = !0), (b.hidden ? k : l)(g)));
            };
          return (h._lsFlush = g), h;
        })(),
        A = function (a, b) {
          return b
            ? function () {
              z(a);
            }
            : function () {
              var b = this,
                c = arguments;
              z(function () {
                a.apply(b, c);
              });
            };
        },
        B = function (a) {
          var b,
            c = 0,
            e = d.throttleDelay,
            g = d.ricTimeout,
            h = function () {
              (b = !1), (c = f.now()), a();
            },
            i =
              m && g > 49
                ? function () {
                  m(h, { timeout: g }),
                    g !== d.ricTimeout && (g = d.ricTimeout);
                }
                : A(function () {
                  k(h);
                }, !0);
          return function (a) {
            var d;
            (a = !0 === a) && (g = 33),
              b ||
              ((b = !0),
                (d = e - (f.now() - c)),
                d < 0 && (d = 0),
                a || d < 9 ? i() : k(i, d));
          };
        },
        C = function (a) {
          var b,
            c,
            d = 99,
            e = function () {
              (b = null), a();
            },
            g = function () {
              var a = f.now() - c;
              a < d ? k(g, d - a) : (m || e)(e);
            };
          return function () {
            (c = f.now()), b || (b = k(g, d));
          };
        };
      !(function () {
        var b,
          c = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            autosizesClass: "lazyautosizes",
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            minSize: 40,
            customMedia: {},
            init: !0,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: !0,
            ricTimeout: 0,
            throttleDelay: 125,
          };
        d = a.lazySizesConfig || a.lazysizesConfig || {};
        for (b in c) b in d || (d[b] = c[b]);
        (a.lazySizesConfig = d),
          k(function () {
            d.init && F();
          });
      })();
      var D = (function () {
        var g,
          l,
          m,
          o,
          p,
          y,
          D,
          F,
          G,
          H,
          I,
          J,
          K = /^img$/i,
          L = /^iframe$/i,
          M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent),
          N = 0,
          O = 0,
          P = 0,
          Q = -1,
          R = function (a) {
            P--, (!a || P < 0 || !a.target) && (P = 0);
          },
          S = function (a) {
            return (
              null == J && (J = "hidden" == x(b.body, "visibility")),
              J ||
              ("hidden" != x(a.parentNode, "visibility") &&
                "hidden" != x(a, "visibility"))
            );
          },
          T = function (a, c) {
            var d,
              f = a,
              g = S(a);
            for (
              F -= c, I += c, G -= c, H += c;
              g && (f = f.offsetParent) && f != b.body && f != e;

            )
              (g = (x(f, "opacity") || 1) > 0) &&
                "visible" != x(f, "overflow") &&
                ((d = f.getBoundingClientRect()),
                  (g =
                    H > d.left &&
                    G < d.right &&
                    I > d.top - 1 &&
                    F < d.bottom + 1));
            return g;
          },
          U = function () {
            var a,
              f,
              h,
              j,
              k,
              m,
              n,
              p,
              q,
              r,
              s,
              t,
              u = c.elements;
            if ((o = d.loadMode) && P < 8 && (a = u.length)) {
              for (f = 0, Q++; f < a; f++)
                if (u[f] && !u[f]._lazyRace)
                  if (!M || (c.prematureUnveil && c.prematureUnveil(u[f])))
                    aa(u[f]);
                  else if (
                    (((p = u[f][i]("data-expand")) && (m = 1 * p)) || (m = O),
                      r ||
                      ((r =
                        !d.expand || d.expand < 1
                          ? e.clientHeight > 500 && e.clientWidth > 500
                            ? 500
                            : 370
                          : d.expand),
                        (c._defEx = r),
                        (s = r * d.expFactor),
                        (t = d.hFac),
                        (J = null),
                        O < s && P < 1 && Q > 2 && o > 2 && !b.hidden
                          ? ((O = s), (Q = 0))
                          : (O = o > 1 && Q > 1 && P < 6 ? r : N)),
                      q !== m &&
                      ((y = innerWidth + m * t),
                        (D = innerHeight + m),
                        (n = -1 * m),
                        (q = m)),
                      (h = u[f].getBoundingClientRect()),
                      (I = h.bottom) >= n &&
                      (F = h.top) <= D &&
                      (H = h.right) >= n * t &&
                      (G = h.left) <= y &&
                      (I || H || G || F) &&
                      (d.loadHidden || S(u[f])) &&
                      ((l && P < 3 && !p && (o < 3 || Q < 4)) || T(u[f], m)))
                  ) {
                    if ((aa(u[f]), (k = !0), P > 9)) break;
                  } else
                    !k &&
                      l &&
                      !j &&
                      P < 4 &&
                      Q < 4 &&
                      o > 2 &&
                      (g[0] || d.preloadAfterLoad) &&
                      (g[0] ||
                        (!p &&
                          (I ||
                            H ||
                            G ||
                            F ||
                            "auto" != u[f][i](d.sizesAttr)))) &&
                      (j = g[0] || u[f]);
              j && !k && aa(j);
            }
          },
          V = B(U),
          W = function (a) {
            var b = a.target;
            if (b._lazyCache) return void delete b._lazyCache;
            R(a),
              s(b, d.loadedClass),
              t(b, d.loadingClass),
              u(b, Y),
              v(b, "lazyloaded");
          },
          X = A(W),
          Y = function (a) {
            X({ target: a.target });
          },
          Z = function (a, b) {
            try {
              a.contentWindow.location.replace(b);
            } catch (c) {
              a.src = b;
            }
          },
          $ = function (a) {
            var b,
              c = a[i](d.srcsetAttr);
            (b = d.customMedia[a[i]("data-media") || a[i]("media")]) &&
              a.setAttribute("media", b),
              c && a.setAttribute("srcset", c);
          },
          _ = A(function (a, b, c, e, f) {
            var g, h, j, l, o, p;
            (o = v(a, "lazybeforeunveil", b)).defaultPrevented ||
              (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)),
                (h = a[i](d.srcsetAttr)),
                (g = a[i](d.srcAttr)),
                f && ((j = a.parentNode), (l = j && n.test(j.nodeName || ""))),
                (p = b.firesLoad || ("src" in a && (h || g || l))),
                (o = { target: a }),
                s(a, d.loadingClass),
                p && (clearTimeout(m), (m = k(R, 2500)), u(a, Y, !0)),
                l && q.call(j.getElementsByTagName("source"), $),
                h
                  ? a.setAttribute("srcset", h)
                  : g && !l && (L.test(a.nodeName) ? Z(a, g) : (a.src = g)),
                f && (h || l) && w(a, { src: g })),
              a._lazyRace && delete a._lazyRace,
              t(a, d.lazyClass),
              z(function () {
                var b = a.complete && a.naturalWidth > 1;
                (p && !b) ||
                  (b && s(a, "ls-is-cached"),
                    W(o),
                    (a._lazyCache = !0),
                    k(function () {
                      "_lazyCache" in a && delete a._lazyCache;
                    }, 9)),
                  "lazy" == a.loading && P--;
              }, !0);
          }),
          aa = function (a) {
            if (!a._lazyRace) {
              var b,
                c = K.test(a.nodeName),
                e = c && (a[i](d.sizesAttr) || a[i]("sizes")),
                f = "auto" == e;
              ((!f && l) ||
                !c ||
                (!a[i]("src") && !a.srcset) ||
                a.complete ||
                r(a, d.errorClass) ||
                !r(a, d.lazyClass)) &&
                ((b = v(a, "lazyunveilread").detail),
                  f && E.updateElem(a, !0, a.offsetWidth),
                  (a._lazyRace = !0),
                  P++,
                  _(a, b, f, e, c));
            }
          },
          ba = C(function () {
            (d.loadMode = 3), V();
          }),
          ca = function () {
            3 == d.loadMode && (d.loadMode = 2), ba();
          },
          da = function () {
            if (!l) {
              if (f.now() - p < 999) return void k(da, 999);
              (l = !0), (d.loadMode = 3), V(), j("scroll", ca, !0);
            }
          };
        return {
          _: function () {
            (p = f.now()),
              (c.elements = b.getElementsByClassName(d.lazyClass)),
              (g = b.getElementsByClassName(
                d.lazyClass + " " + d.preloadClass
              )),
              j("scroll", V, !0),
              j("resize", V, !0),
              a.MutationObserver
                ? new MutationObserver(V).observe(e, {
                  childList: !0,
                  subtree: !0,
                  attributes: !0,
                })
                : (e[h]("DOMNodeInserted", V, !0),
                  e[h]("DOMAttrModified", V, !0),
                  setInterval(V, 999)),
              j("hashchange", V, !0),
              [
                "focus",
                "mouseover",
                "click",
                "load",
                "transitionend",
                "animationend",
                "webkitAnimationEnd",
              ].forEach(function (a) {
                b[h](a, V, !0);
              }),
              /d$|^c/.test(b.readyState)
                ? da()
                : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)),
              c.elements.length ? (U(), z._lsFlush()) : V();
          },
          checkElems: V,
          unveil: aa,
          _aLSL: ca,
        };
      })(),
        E = (function () {
          var a,
            c = A(function (a, b, c, d) {
              var e, f, g;
              if (
                ((a._lazysizesWidth = d),
                  (d += "px"),
                  a.setAttribute("sizes", d),
                  n.test(b.nodeName || ""))
              )
                for (
                  e = b.getElementsByTagName("source"), f = 0, g = e.length;
                  f < g;
                  f++
                )
                  e[f].setAttribute("sizes", d);
              c.detail.dataAttr || w(a, c.detail);
            }),
            e = function (a, b, d) {
              var e,
                f = a.parentNode;
              f &&
                ((d = y(a, f, d)),
                  (e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b })),
                  e.defaultPrevented ||
                  ((d = e.detail.width) &&
                    d !== a._lazysizesWidth &&
                    c(a, f, e, d)));
            },
            f = function () {
              var b,
                c = a.length;
              if (c) for (b = 0; b < c; b++) e(a[b]);
            },
            g = C(f);
          return {
            _: function () {
              (a = b.getElementsByClassName(d.autosizesClass)), j("resize", g);
            },
            checkElems: g,
            updateElem: e,
          };
        })(),
        F = function () {
          F.i || ((F.i = !0), E._(), D._());
        };
      return (c = {
        cfg: d,
        autoSizer: E,
        loader: D,
        init: F,
        uP: w,
        aC: s,
        rC: t,
        hC: r,
        fire: v,
        gW: y,
        rAF: z,
      });
    }
  });
  /*! ls.rias.min.ks - v4.1.8 */
  !(function (a, b) {
    var c = function () {
      b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
    };
    (b = b.bind(null, a, a.document)),
      "object" == typeof module && module.exports
        ? b(require("lazysizes"))
        : a.lazySizes
          ? c()
          : a.addEventListener("lazyunveilread", c, !0);
  })(window, function (a, b, c) {
    "use strict";
    function d(b, c) {
      var d,
        e,
        f,
        g,
        h = a.getComputedStyle(b);
      (e = b.parentNode),
        (g = { isPicture: !(!e || !m.test(e.nodeName || "")) }),
        (f = function (a, c) {
          var d = b.getAttribute("data-" + a);
          if (!d) {
            var e = h.getPropertyValue("--ls-" + a);
            e && (d = e.trim());
          }
          if (d) {
            if ("true" == d) d = !0;
            else if ("false" == d) d = !1;
            else if (l.test(d)) d = parseFloat(d);
            else if ("function" == typeof j[a]) d = j[a](b, d);
            else if (q.test(d))
              try {
                d = JSON.parse(d);
              } catch (a) { }
            g[a] = d;
          } else
            a in j && "function" != typeof j[a]
              ? (g[a] = j[a])
              : c && "function" == typeof j[a] && (g[a] = j[a](b, d));
        });
      for (d in j) f(d);
      return (
        c.replace(p, function (a, b) {
          b in g || f(b, !0);
        }),
        g
      );
    }
    function e(a, b) {
      var c = [],
        d = function (a, c) {
          return k[typeof b[c]] ? b[c] : a;
        };
      return (
        (c.srcset = []),
        b.absUrl && (s.setAttribute("href", a), (a = s.href)),
        (a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d)),
        b.widths.forEach(function (d) {
          var e = b.widthmap[d] || d,
            f = b.aspectratio || b.ratio,
            g = !b.aspectratio && j.traditionalRatio,
            h = {
              u: a
                .replace(n, e)
                .replace(
                  o,
                  f ? (g ? Math.round(d * f) : Math.round(d / f)) : ""
                ),
              w: d,
            };
          c.push(h), c.srcset.push((h.c = h.u + " " + d + "w"));
        }),
        c
      );
    }
    function f(a, c, d) {
      var f = 0,
        g = 0,
        h = d;
      if (a) {
        if ("container" === c.ratio) {
          for (f = h.scrollWidth, g = h.scrollHeight; !((f && g) || h === b);)
            (h = h.parentNode), (f = h.scrollWidth), (g = h.scrollHeight);
          f && g && (c.ratio = g / f);
        }
        (a = e(a, c)),
          (a.isPicture = c.isPicture),
          u && "IMG" == d.nodeName.toUpperCase()
            ? d.removeAttribute(i.srcsetAttr)
            : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")),
          Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 });
      }
    }
    function g(a, b) {
      var e = d(a, b);
      return (
        j.modifyOptions.call(a, { target: a, details: e, detail: e }),
        c.fire(a, "lazyriasmodifyoptions", e),
        e
      );
    }
    function h(a) {
      return (
        a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) ||
        a.getAttribute(i.srcsetAttr) ||
        a.getAttribute(i.srcAttr) ||
        a.getAttribute("data-pfsrcset") ||
        ""
      );
    }
    var i,
      j,
      k = { string: 1, number: 1 },
      l = /^\-*\+*\d+\.*\d*$/,
      m = /^picture$/i,
      n = /\s*\{\s*width\s*\}\s*/i,
      o = /\s*\{\s*height\s*\}\s*/i,
      p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      q = /^\[.*\]|\{.*\}$/,
      r = /^(?:auto|\d+(px)?)$/,
      s = b.createElement("a"),
      t = b.createElement("img"),
      u = "srcset" in t && !("sizes" in t),
      v = !!a.HTMLPictureElement && !u;
    !(function () {
      var b,
        d = function () { },
        e = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: !1,
          modifyOptions: d,
          widthmap: {},
          ratio: !1,
          traditionalRatio: !1,
          aspectratio: !1,
        };
      (i = (c && c.cfg) || a.lazySizesConfig),
        i || ((i = {}), (a.lazySizesConfig = i)),
        i.supportsType ||
        (i.supportsType = function (a) {
          return !a;
        }),
        i.rias || (i.rias = {}),
        "widths" in (j = i.rias) ||
        ((j.widths = []),
          (function (a) {
            for (var b, c = 0; !b || b < 3e3;)
              (c += 5), c > 30 && (c += 1), (b = 36 * c), a.push(b);
          })(j.widths));
      for (b in e) b in j || (j[b] = e[b]);
    })(),
      addEventListener(
        "lazybeforesizes",
        function (a) {
          if (a.detail.instance == c) {
            var b, d, e, k, l, m, o, p, q, s, t, u, x;
            if (
              ((b = a.target),
                a.detail.dataAttr &&
                !a.defaultPrevented &&
                !j.disabled &&
                (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) &&
                r.test(q))
            ) {
              if (
                ((d = h(b)),
                  (e = g(b, d)),
                  (t = n.test(e.prefix) || n.test(e.postfix)),
                  e.isPicture && (k = b.parentNode))
              )
                for (
                  l = k.getElementsByTagName("source"), m = 0, o = l.length;
                  m < o;
                  m++
                )
                  (t || n.test((p = h(l[m])))) && (f(p, e, l[m]), (u = !0));
              t || n.test(d)
                ? (f(d, e, b), (u = !0))
                : u &&
                ((x = []),
                  (x.srcset = []),
                  (x.isPicture = !0),
                  Object.defineProperty(b, "_lazyrias", {
                    value: x,
                    writable: !0,
                  })),
                u &&
                (v
                  ? b.removeAttribute(i.srcAttr)
                  : "auto" != q &&
                  ((s = { width: parseInt(q, 10) }),
                    w({ target: b, detail: s })));
            }
          }
        },
        !0
      );
    var w = (function () {
      var d = function (a, b) {
        return a.w - b.w;
      },
        e = function (a) {
          var b,
            c,
            d = a.length,
            e = a[d - 1],
            f = 0;
          for (f; f < d; f++)
            if (((e = a[f]), (e.d = e.w / a.w), e.d >= a.d)) {
              !e.cached &&
                (b = a[f - 1]) &&
                b.d > a.d - 0.13 * Math.pow(a.d, 2.2) &&
                ((c = Math.pow(b.d - 0.6, 1.6)),
                  b.cached && (b.d += 0.15 * c),
                  b.d + (e.d - a.d) * c > a.d && (e = b));
              break;
            }
          return e;
        },
        f = function (a, b) {
          var d;
          return (
            !a._lazyrias &&
            c.pWS &&
            (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length &&
            (Object.defineProperty(a, "_lazyrias", {
              value: d,
              writable: !0,
            }),
              b &&
              a.parentNode &&
              (d.isPicture =
                "PICTURE" == a.parentNode.nodeName.toUpperCase())),
            a._lazyrias
          );
        },
        g = function (b) {
          var d = a.devicePixelRatio || 1,
            e = c.getX && c.getX(b);
          return Math.min(e || d, 2.4, d);
        },
        h = function (b, c) {
          var h, i, j, k, l, m;
          if (((l = b._lazyrias), l.isPicture && a.matchMedia))
            for (
              i = 0,
              h = b.parentNode.getElementsByTagName("source"),
              j = h.length;
              i < j;
              i++
            )
              if (
                f(h[i]) &&
                !h[i].getAttribute("type") &&
                (!(k = h[i].getAttribute("media")) ||
                  (matchMedia(k) || {}).matches)
              ) {
                l = h[i]._lazyrias;
                break;
              }
          return (
            (!l.w || l.w < c) && ((l.w = c), (l.d = g(b)), (m = e(l.sort(d)))),
            m
          );
        },
        j = function (d) {
          if (d.detail.instance == c) {
            var e,
              g = d.target;
            if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf))
              return void b.removeEventListener("lazybeforesizes", j);
            ("_lazyrias" in g || (d.detail.dataAttr && f(g, !0))) &&
              (e = h(g, d.detail.width)) &&
              e.u &&
              g._lazyrias.cur != e.u &&
              ((g._lazyrias.cur = e.u),
                (e.cached = !0),
                c.rAF(function () {
                  g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u);
                }));
          }
        };
      return (
        v ? (j = function () { }) : addEventListener("lazybeforesizes", j), j
      );
    })();
  });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== "undefined" && theme.hasOwnProperty("settings"))
  theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    filterTreeMobileStyle: "style1",
    // Placeholder
    showPlaceholderProductList: true,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass:
      "boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2",
    enableOTP: true,
    aspect_ratio: boostPFSThemeConfig.custom.aspect_ratio,
    cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.product_img_crop,
    defaultDisplay: "grid",
    selectOptionContainer: ".boost-pfs-filter-product-item-image",
    keepScrollbackPositionType: "history",
  },
  selector: {
    otpButtons: ".boost-pfs-filter-product-item-image",
  },
};

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    firstVariant = {},
    boostPFSImgDefaultSrc =
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    isFlooringCollection = false,
    boostPFSRangeWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048,
    ];

  BoostPFS.inject(this);
  boostPFSFilterConfig.general.separateRefineByFromFilter =
    jQ(".boost-pfs-filter-tree-h").length &&
      !Utils.isMobile() > 0 &&
      boostPFSThemeConfig.custom.filter_tree_horizontal_style != "style-expand"
      ? true
      : false;
  Selector.stickyElementDesktop =
    jQ(".boost-pfs-filter-tree-v").length > 0 && !Utils.isMobile()
      ? ".boost-pfs-filter-left-col"
      : ".boost-pfs-filter-tree";

      var collectionId = [79866855482, 79866200122, 79957786682, 91776942138, 79964864570, 79904866362, 79905456186, 79905390650, 79904833594]
      if (collectionId.indexOf(boostPFSConfig.general.collection_id) > -1) {
        boostPFSFilterConfig.general.defaultDisplay = 'list';
        var displayValue = boostPFSFilterConfig.general.defaultDisplay;
      }else{
        var displayValue = Utils.getParam("display");
      }
      
  /* start-boost-custom */
  /* #boost-118852: change the limit on mobile devices. */
  if (Utils.isMobile()) boostPFSFilterConfig.general.limit = 14;
  /* end-boost-custom */

  /* Start-Boost-161717 */
  var collectionArr = [
    "head",
    "neck",
    "shoulders",
    "biceps",
    "elbow-joints",
    "forearms",
    "wrist",
    "hands",
    "chest",
    "abdominals",
    "hips",
    "quads",
    "knees",
    "shin",
    "ankle",
    "feet",
    "back",
    "lower-back",
    "triceps",
    "glutes",
    "hamstrings",
    "calf",
    "sole",
    "accessories",
    "bumper-olympic-weight-plates-1",
    "dumbbells",
    "kettlebells",
    "weightlifting-bars",
    "cages-racks-rigs",
    "benches",
    "home-gym-packages",
    "storage-racks",
    "home-gyms",
    "weight-plate-storage",
    "dumbbell-racks",
    "dumbbell-accessories",
    "cable-machines",
    "selectorized-functional-trainers",
    "complete-functional-trainers",
    "plate-loaded-functional-trainers",
    "all-in-one-home-gyms",
    "single-stack",
    "multi-stack",
    "cable-attachments-1",
    "power-racks",
    "half-racks",
    "squat-racks-stands",
    "smith-machines",
    "adjustable-benches",
    "flat-benches",
    "bench-attachments",
    "upper-body",
    "chest-machines",
    "lat-machines",
    "bicep-tricep-machines",
    "core-back",
    "abdominal-machines",
    "back-machines",
    "knee-raise-machines",
    "lower-body",
    "leg-press",
    "leg-extension-curl-machines",
    "calf-thigh-machines",
    "glute-hip-machines",
    "leverage-machines",
    "standing",
    "seated",
    "add-ons-cable-attachments",
    "rig-attachments",
    "power-rack-attachments",
    "weight-stack-add-ons",
    "plate-loaded-1",
    "upper-body-plate-loaded",
    "lower-body-plate-loaded",
    "core-body-plate-loaded",
    "selectorized-machines"
  ];
  if (collectionArr.includes(boostPFSAppConfig.general.collection_handle))
    boostPFSFilterConfig.general.limit = 16;
  if (boostPFSAppConfig.general.collection_handle == "benches")
    boostPFSFilterConfig.general.limit = 15;
  /* End-Boost-161717 */

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }

    /* Fix issue "You save price also divided by ACF field" */
    for (var collection of data.collections) {
      if (collection.id == 80195977274) {
        isFlooringCollection = true;
        break;
      } else {
        isFlooringCollection = false;
      }
    }
    /* End fix */
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  function determineDefaultVariant(variants, metafields) {

    // Mobile: Only show lowest price 
    const metafieldMap = metafields.reduce((map, field) => {
    const isMobile = window.innerWidth < 767;
    
        if (field.namespace === "PricePerLB") {
  
          map[field.id] = parseFloat(field.value);
  
        } else {
          if(isMobile && field.namespace === "price-per-sq-ft"){
            map[field.id] = parseFloat(field.value);
          }
        } 
    
          return map;
    
    }, {});



    if (Object.keys(metafieldMap).length > 0) {

      // Calculate adjusted prices and find the variant with the smallest adjusted price

      let minPrice = Infinity;

      let defaultVariantId = null;



      variants.forEach((variant) => {

        const metafieldValue = metafieldMap[variant.id];

        if (metafieldValue) {

          const adjustedPrice = variant.price / metafieldValue;

          if (adjustedPrice < minPrice) {

            minPrice = adjustedPrice;

            defaultVariantId = variant.id;

          }

        }

      });



      return defaultVariantId;

    } else {

      // Fallback to the first variant if no PricePerLB metafields are present

      return variants[0].id;

    }

  }
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;

    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    const variants = data.variants;
    const metafields = data.metafields;
    // Determine the default variant
    const defaultVariantId = determineDefaultVariant(variants, metafields);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    /* Start-Boost-161717 */
    itemHtml = itemHtml.replace(
      /{{itemGridClass}}/g,
      collectionArr.includes(boostPFSAppConfig.general.collection_handle)
        ? "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"
        : "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4"
    );
    /* End-Boost-161717 */

    var isbenchesCol =
      boostPFSAppConfig.general.collection_handle == "benches"
        ? "col-xl-3"
        : "col-xl-4";

    //promo
    var proHtml =
      '<div class="foursoltimage col-12 col-sm-6 col-md-6 col-lg-6 ' +
      isbenchesCol +
      ' boost-root-item">' +
      '<div class="product-collection">' +
      '<div class="product-collection__wrapper mb-30 mb-lg-30">' +
      '<a href="{{fourthLink}}">' +
      '<img src="{{fourthImage}}" loading="lazy">' +
      "</a>" +
      "</div>" +
      "</div>" +
      "</div>";

    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    var saleClass = onSale ? boostPFSTemplate.saleClass : "";

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Grid Width class
    itemHtml = itemHtml.replace(
      /{{gridWidthClass}}/g,
      buildGridWidthClass(data)
    );
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add TAG Label
    itemHtml = itemHtml.replace(
      /{{itemTagLabels}}/g,
      buildTagLabels(data, false)
    );
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(
      /{{itemPrice}}/g,
      buildPrice(data, data.variants[0].id)
    );
    // Add Save Price
    itemHtml = itemHtml.replace(
      /{{itemSavePrice}}/g,
      buildSavePrice(data, data.variants[0].id, "product")
    );

    // Add Review
    if (
      typeof Integration === "undefined" ||
      (typeof Integration != "undefined" &&
        typeof Integration.hascompileTemplate == "function" &&
        !Integration.hascompileTemplate("reviews"))
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // itemActiveSwapClass
    itemHtml = itemHtml.replace(
      /{{itemActiveSwapClass}}/g,
      buildActiveSwapClass(data)
    );

    // Add flooring link
    itemHtml = itemHtml.replace(/{{flooringLink}}/g, buildMySpaceLink(data));

    // Start Boost 232076
    // Add Item On Display
    var itemDeliveryAbility = Utils.getProductMetafield(
      data,
      "Ability",
      "ability"
    );
    var itemInStock = Utils.getProductMetafield(data, "In-Stock", "In-Stock");
    var itemOnDisplay = '<div class="boost-new-info">';
    var numberInStock = 0;
    for (var i = 0; i < data.variants.length; i++) {
      numberInStock += data.variants[i].inventory_quantity;
    }
    if (
      numberInStock > 0 ||
      (itemDeliveryAbility == "true" && itemInStock == "true")
    ) {
      itemOnDisplay +=
        '<div class="boost-on-display"><img src="https://www.sparksfitness.net/cdn/shop/t/97/assets/green-check-mark.png?v=99932586340666238071679551901"><strong>On Display</strong><a href="https://www.google.com/maps/place/Sparks+Fitness+Equipment/@32.9490721,-96.8315522,17z/data=!3m1!4b1!4m5!3m4!1s0x864c21a770a2aa0f:0xf0def3e95e229103!8m2!3d32.9490721!4d-96.8293635" target="_blank"> Dallas, Texas (5.6 miles away)</a></div>';
      itemOnDisplay +=
        '<div class="boost-in-stock"><img src="https://www.sparksfitness.net/cdn/shop/t/97/assets/green-check-mark.png?v=99932586340666238071679551901"><strong>In Stock</strong><a href="https://www.google.com/maps/place/Sparks+Fitness+Equipment/@32.9490721,-96.8315522,17z/data=!3m1!4b1!4m5!3m4!1s0x864c21a770a2aa0f:0xf0def3e95e229103!8m2!3d32.9490721!4d-96.8293635" target="_blank"> Click For Store Directions</a></div>';
    } else if (itemDeliveryAbility == "true") {
      itemOnDisplay +=
        '<div class="boost-on-display"><img src="https://www.sparksfitness.net/cdn/shop/t/97/assets/green-check-mark.png?v=99932586340666238071679551901"><strong>On Display</strong><a href="https://www.google.com/maps/place/Sparks+Fitness+Equipment/@32.9490721,-96.8315522,17z/data=!3m1!4b1!4m5!3m4!1s0x864c21a770a2aa0f:0xf0def3e95e229103!8m2!3d32.9490721!4d-96.8293635" target="_blank"> Dallas, Texas (5.6 miles away)</a></div>';
    } else if (itemInStock == "true") {
      itemOnDisplay +=
        '<div class="boost-in-stock"><img src="https://www.sparksfitness.net/cdn/shop/t/97/assets/green-check-mark.png?v=99932586340666238071679551901"><strong>In Stock</strong><a href="https://www.google.com/maps/place/Sparks+Fitness+Equipment/@32.9490721,-96.8315522,17z/data=!3m1!4b1!4m5!3m4!1s0x864c21a770a2aa0f:0xf0def3e95e229103!8m2!3d32.9490721!4d-96.8293635" target="_blank"> Click For Store Directions</a></div>';
    }
    itemOnDisplay += "</div>";
    itemHtml = itemHtml.replace(/{{itemOnDisplay}}/g, itemOnDisplay);
    // End Boost 232076

    // Add Color Swatches
    itemHtml = itemHtml.replace(
      /{{itemSwatches}}/g,
      buildProductOptionSwatches(data)
    );

    // itemHtml = itemHtml.replace(/{{itemDefaultVariant}}/g, data.variants[0].id);
    itemHtml = itemHtml.replace(/{{itemDefaultVariant}}/g, defaultVariantId);



    var itemDelivery = Utils.getProductMetafield(
      data,
      "DeliveryTimeEstimate",
      "delivery_time_estimate"
    );
    if (itemDelivery !== null) {
      var itemDeliveryHtml = '<div class="item-delivery">';
      itemDeliveryHtml += '<div class="content">';
      itemDeliveryHtml +=
        '<div class="content-desc">' + itemDelivery + "</div>";
      itemDeliveryHtml += "</div>";
      itemDeliveryHtml += "</div>";
    } else {
      var itemDeliveryHtml = '<div class="item-delivery">';
      itemDeliveryHtml += '<div class="content">';
      itemDeliveryHtml +=
        '<div class="content-desc">' +
        boostPFSThemeConfig.custom.delivery_time_estimate +
        "</div>";
      itemDeliveryHtml += "</div>";
      itemDeliveryHtml += "</div>";
    }
    itemHtml = itemHtml.replace(/{{itemExtraInfo}}/g, itemDeliveryHtml);

    var itemInstallation = Utils.getProductMetafield(
      data,
      "installation-custom",
      "installation-custom-value"
    );
    if (itemInstallation !== null) {
      var installationHtml = '<div class="installation-part part">';
      installationHtml += '<div class="part-icon">';
      installationHtml +=
        '<img src="https://cdn.shopify.com/s/files/1/0134/3275/0138/files/Installation_1_1.png?v=1648635551" style="max-width: 20px;object-fit: contain;">';
      installationHtml += "</div>";
      installationHtml += '<div class="part-content">';
      installationHtml +=
        '<div class="part-content-title">Installation: </div>';
      installationHtml +=
        '<div class="part-content-desc"><span class="green">' +
        itemInstallation +
        "</span></div>";
      installationHtml += "</div>";
      installationHtml += "</div>";
      itemHtml = itemHtml.replace(/{{itemInstallation}}/g, installationHtml);
    } else {
      var installationHtml = '<div class="installation-part part">';
      installationHtml += '<div class="part-icon">';
      installationHtml +=
        '<img src="https://cdn.shopify.com/s/files/1/0134/3275/0138/files/Installation_1_1.png?v=1648635551" style="max-width: 20px;object-fit: contain;">';
      installationHtml += "</div>";
      installationHtml += '<div class="part-content">';
      installationHtml +=
        '<div class="part-content-title">Installation: </div>';
      installationHtml +=
        '<div class="part-content-desc"><span class="green">In 3 Days</span></div>';
      installationHtml += "</div>";
      installationHtml += "</div>";
      itemHtml = itemHtml.replace(/{{itemInstallation}}/g, installationHtml);
    }

    var metafield = data.metafields.filter(
      (e) => e.namespace === "Home_delivery"
    );
    if (metafield.length != 0) {
      var valueMetafield = metafield[0].value;
    } else {
    }

    var itemDeliveryHtml = '<div class="free-delivery-part part">';
    itemDeliveryHtml += '<div class="part-icon">';
    itemDeliveryHtml +=
      '<svg aria-hidden="true" role="img" viewBox="0 0 100 100" style="fill:#1D252C;width:20px;height:20px;margin-right:6px"><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><svg id="Delivery_Line_Sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M29.552 17.247h-.521l-2.56-5.197a.979.979 0 00-.877-.546h-4.05V4.77a.978.978 0 00-.978-.978H4.026a.978.978 0 00-.978.978v2.148a.978.978 0 001.955 0v-1.17H19.59V17.23H5.003v-.5a.978.978 0 00-1.955 0v5.668a2.431 2.431 0 002.428 2.428h.797a3.534 3.534 0 003.523 3.381 3.534 3.534 0 003.523-3.381H22.253c.084 1.877 1.624 3.381 3.522 3.381s3.44-1.504 3.523-3.381h.254A2.45 2.45 0 0032 22.38v-2.685a2.45 2.45 0 00-2.448-2.448zM9.796 26.254a1.585 1.585 0 010-3.166c.873 0 1.583.71 1.583 1.582 0 .874-.71 1.584-1.583 1.584zm15.979 0a1.585 1.585 0 111.584-1.583c0 .873-.71 1.583-1.584 1.583zm4.27-3.874c0 .27-.221.492-.493.492h-.747c-.617-1.036-1.738-1.74-3.03-1.74s-2.412.704-3.03 1.74h-9.919a3.528 3.528 0 00-3.03-1.74 3.527 3.527 0 00-3.03 1.74h-1.29a.474.474 0 01-.473-.473v-3.213h15.563c.005 0 .01-.003.014-.003.033.003.062.02.096.02.54 0 .977-.438.977-.978V13.46h3.333l2.559 5.197a.978.978 0 00.877.545h1.13c.272 0 .493.221.493.493v2.685z"></path><path d="M8.98 13.44a.978.978 0 00-.978-.975h-.003l-7.024.02a.978.978 0 00.003 1.955H.98l7.024-.02a.978.978 0 00.976-.98zM3.994 11.153l4.02-.007a.978.978 0 00-.001-1.955H8.01l-4.02.007a.978.978 0 000 1.955h.003z"></path></svg></svg></svg>';
    itemDeliveryHtml += "</div>";
    itemDeliveryHtml += '<div class="part-content">';
    itemDeliveryHtml +=
      '<div class="part-content-title">Delivery or Installation: </div>';
    if (metafield.length != 0) {
      var valueMetafield = metafield[0].value;
      itemDeliveryHtml +=
        '<div class="part-content-desc"><span style="color:#040c13"><span>' +
        valueMetafield +
        "</span></span></div>";
    } else {
      itemDeliveryHtml +=
        '<div class="part-content-desc"><span style="color:#040c13" id="DeliveryDate"><span></span></span></div>';
    }
    itemDeliveryHtml += "</div>";
    itemDeliveryHtml += "</div>";
    itemHtml = itemHtml.replace(/{{itemDelivery}}/g, itemDeliveryHtml);

    var itemPickup = Utils.getProductMetafield(
      data,
      "delivery-pickup-valu",
      "delivery-pickup-value"
    );
    if (itemPickup !== null) {
      var itemPickupyHtml = '<div class="pickup-part part">';
      itemPickupyHtml += '<div class="part-icon">';
      itemPickupyHtml +=
        '<svg aria-hidden="true" role="img" viewBox="0 0 100 100" style="fill:#1D252C;width:20px;height:20px;margin-right:6px"><svg id="Store_Line_Sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xml:space="preserve"><path d="M28.9 11.92h-3.78a.98.98 0 0 0 0 1.96h3.79c.14 0 .25.12.25.25V28c0 .14-.11.26-.25.26h-5.03v-4.6c0-.84-.68-1.52-1.52-1.52h-9.72c-.82 0-1.44.65-1.44 1.52v4.6H6.24a.27.27 0 0 1-.27-.27V16.47h15.7c.54 0 .98-.44.98-.98V2.84a.98.98 0 0 0-.98-.97H5.8c-.25 0-.49.1-.67.26L1.2 5.85c-.2.19-.3.45-.3.72v5.1c0 .26.1.51.3.7l2.84 2.77c0 .05-.03.09-.03.14v12.7c0 1.23 1 2.23 2.23 2.23H28.9c1.22 0 2.2-1 2.2-2.21V14.13a2.2 2.2 0 0 0-2.2-2.2zM2.86 7 6.2 3.82h14.5v10.69H6.2l-3.35-3.26V7zm19.08 21.27h-3.48V24.1h3.48v4.16zm-8.78-4.16h3.34v4.16h-3.34V24.1zM6.38 9.06a.98.98 0 0 1-1.96 0c0-.54.45-.98.98-.98.55 0 .98.44.98.98z"></path></svg></svg>';
      itemPickupyHtml += "</div>";
      itemPickupyHtml += '<div class="part-content">';
      itemPickupyHtml +=
        '<div class="part-content-title">Free In-Store Pickup: </div>';
      itemPickupyHtml += '<div class="part-content-desc">';
      // itemPickupyHtml += '<div>' + boostPFSThemeConfig.custom.delivery_pickup_value + '</div>';
      itemPickupyHtml +=
        '<div><span class="green"><a href="https://maps.google.com/maps?ll=32.949072,-96.829363&z=15&t=m&hl=en&gl=IN&mapclient=embed&cid=17356578197564723459" target="_blank" style="text-align:left">Get Store Directions</a></span></div>';
      itemPickupyHtml += "</div>";
      itemPickupyHtml += "</div>";
      itemPickupyHtml += "</div>";
      itemHtml = itemHtml.replace(/{{itemPickup}}/g, itemPickupyHtml);
    } else {
      var itemPickupyHtml = '<div class="pickup-part part">';
      itemPickupyHtml += '<div class="part-icon">';
      itemPickupyHtml +=
        '<svg aria-hidden="true" role="img" viewBox="0 0 100 100" style="fill:#1D252C;width:20px;height:20px;margin-right:6px"><svg id="Store_Line_Sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xml:space="preserve"><path d="M28.9 11.92h-3.78a.98.98 0 0 0 0 1.96h3.79c.14 0 .25.12.25.25V28c0 .14-.11.26-.25.26h-5.03v-4.6c0-.84-.68-1.52-1.52-1.52h-9.72c-.82 0-1.44.65-1.44 1.52v4.6H6.24a.27.27 0 0 1-.27-.27V16.47h15.7c.54 0 .98-.44.98-.98V2.84a.98.98 0 0 0-.98-.97H5.8c-.25 0-.49.1-.67.26L1.2 5.85c-.2.19-.3.45-.3.72v5.1c0 .26.1.51.3.7l2.84 2.77c0 .05-.03.09-.03.14v12.7c0 1.23 1 2.23 2.23 2.23H28.9c1.22 0 2.2-1 2.2-2.21V14.13a2.2 2.2 0 0 0-2.2-2.2zM2.86 7 6.2 3.82h14.5v10.69H6.2l-3.35-3.26V7zm19.08 21.27h-3.48V24.1h3.48v4.16zm-8.78-4.16h3.34v4.16h-3.34V24.1zM6.38 9.06a.98.98 0 0 1-1.96 0c0-.54.45-.98.98-.98.55 0 .98.44.98.98z"></path></svg></svg>';
      itemPickupyHtml += "</div>";
      itemPickupyHtml += '<div class="part-content">';
      itemPickupyHtml +=
        '<div class="part-content-title">Free In-Store Pickup:</div>';
      itemPickupyHtml += '<div class="part-content-desc">';
      // itemPickupyHtml += '<div>' + boostPFSThemeConfig.custom.delivery_pickup_value + '</div>';
      itemPickupyHtml +=
        '<div><span class="green"><a href="https://maps.google.com/maps?ll=32.949072,-96.829363&z=15&t=m&hl=en&gl=IN&mapclient=embed&cid=17356578197564723459" target="_blank" style="text-align:left">Get Store Directions</a></span></div>';
      itemPickupyHtml += "</div>";
      itemPickupyHtml += "</div>";
      itemPickupyHtml += "</div>";
      itemHtml = itemHtml.replace(/{{itemPickup}}/g, itemPickupyHtml);
    }

    var itemAvailableHtml =
      '<div class="confirm-availability-btn btn-link h6 d-flex align-items-center mb-10 js-popup-button" id="confrim-availability-' +
      data.id +
      '" data-js-popup-button="confirm-availability" data-js-popup-dynamic-content="test">';
    itemAvailableHtml += "<span>Confirm Availability</span>";
    itemAvailableHtml += "</div>";
    itemHtml = itemHtml.replace(/{{itemAvailable}}/g, itemAvailableHtml);

    var addToCartHtml = "";
    var variantNotAvailable = data.variants.filter(function (e) {
      return e.available == false;
    });
    if (data.available) {
      var priceMetafield = Utils.getProductMetafield(
        data,
        "hide-add-to-cart",
        "hide-add-to-cart"
      );
      var accordionMetafield = Utils.getProductMetafield(
        data,
        "AccordionTitle",
        "AccordionTitle"
      );
      if (accordionMetafield) {
        addToCartHtml = `<div class="product-collection__buttons d-flex flex-column flex-lg-row align-items-lg-center flex-wrap mt-5 mt-lg-10">
                    <div class="product-collection__button-add-to-cart mb-10">
                       <a href="{{itemUrl}}" class="btn ${boostPFSConfig.custom.animation_enabled
            ? "btn--animation-shake"
            : ""
          }">View Detail</a>
                    </div>
                    <div class="product-collection__buttons-section d-flex px-lg-10">
                      <div class="product-collection__button-add-to-wishlist mb-10">
                        <a href="/account" class="btn btn--text btn--status px-lg-6 js-store-lists-add-wishlist">
                          <i class="mb-1 ml-1">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
                              <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
                        c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
                        c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
                        c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
                        c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
                        s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
                        S20.552,9.968,20.324,10.515z"></path>
                            </svg>
                          </i>
                          <i class="mb-1 ml-1" data-button-content="added">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
                              <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S22.147,7.265,21.861,6.568z"></path>
                            </svg>
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>`;
      } else if (data.template_suffix == "requires-contact") {
        addToCartHtml = `<a href="/pages/store-locator" class="btn order_from_store_btn ${boostPFSConfig.custom.animation_enabled ? "btn--animation-shake" : ""
          }">Order from store</a>
    				<div class="product-collection__button-add-to-wishlist mb-10">
                        <a href="/account" class="btn btn--text btn--status px-lg-6 js-store-lists-add-wishlist">
                          <i class="mb-1 ml-1">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
                              <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
                        c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
                        c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
                        c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
                        c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
                        s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
                        S20.552,9.968,20.324,10.515z"></path>
                            </svg>
                          </i>
                          <i class="mb-1 ml-1" data-button-content="added">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
                              <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S22.147,7.265,21.861,6.568z"></path>
                            </svg>
                          </i>
                        </a>
                      </div>
                    </div>`;
      } else if (
        priceMetafield == "true" ||
        data.tags.indexOf("price_hidden") !== -1
      ) {
        addToCartHtml = `<a href="/pages/store-locator" class="btn order_from_store_btn">Order from store</a>
    				<div class="product-collection__button-add-to-wishlist mb-10">
                        <a href="/account" class="btn btn--text btn--status px-lg-6 js-store-lists-add-wishlist">
                          <i class="mb-1 ml-1">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
                              <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
                        c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
                        c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
                        c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
                        c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
                        s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
                        S20.552,9.968,20.324,10.515z"></path>
                            </svg>
                          </i>
                          <i class="mb-1 ml-1" data-button-content="added">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
                              <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S22.147,7.265,21.861,6.568z"></path>
                            </svg>
                          </i>
                        </a>
                      </div>
                    </div>`;
      } else if (
        firstVariant.inventory_quantity <= -50 &&
        firstVariant.inventory_policy == "continue"
      ) {
        addToCartHtml = `<div class="product-collection__buttons d-flex flex-column flex-lg-row align-items-lg-center flex-wrap mt-5 mt-lg-10">
                    <div class="product-collection__button-add-to-cart mb-10">
                    	<button type="submit" class="cp-add-to-cart js-product-button-add-to-cart btn btn--full btn--animated ${boostPFSConfig.custom.animation_enabled
            ? "btn--animation-shake"
            : ""
          }">
                            <span class="d-flex flex-center"> Pre Order </span>
                        </button>
                    </div>
                    <div class="product-collection__buttons-section d-flex px-lg-10">
                      <div class="product-collection__button-add-to-wishlist mb-10">
                        <a href="/account" class="btn btn--text btn--status px-lg-6 js-store-lists-add-wishlist">
                          <i class="mb-1 ml-1">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
                              <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
                        c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
                        c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
                        c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
                        c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
                        s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
                        S20.552,9.968,20.324,10.515z"></path>
                            </svg>
                          </i>
                          <i class="mb-1 ml-1" data-button-content="added">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
                              <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S22.147,7.265,21.861,6.568z"></path>
                            </svg>
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>`;
      } else {
        addToCartHtml = `<div class="product-collection__buttons d-flex flex-column flex-lg-row align-items-lg-center flex-wrap mt-5 mt-lg-10">
                    <div class="product-collection__button-add-to-cart mb-10">
                    	<button type="submit" class="cp-add-to-cart js-product-button-add-to-cart btn btn--full btn--animated ${boostPFSConfig.custom.animation_enabled
            ? "btn--animation-shake"
            : ""
          }">
                            <span class="d-flex flex-center add-to-cart-text"> Add to cart </span>
                        </button>
                    </div>
                    <div class="product-collection__buttons-section d-flex px-lg-10">
                      <div class="product-collection__button-add-to-wishlist mb-10">
                        <a href="/account" class="btn btn--text btn--status px-lg-6 js-store-lists-add-wishlist">
                          <i class="mb-1 ml-1">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
                              <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
                        c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
                        c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
                        c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
                        c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
                        s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
                        S20.552,9.968,20.324,10.515z"></path>
                            </svg>
                          </i>
                          <i class="mb-1 ml-1" data-button-content="added">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
                              <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                        s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                        c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                        s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                        s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                        c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                        S22.147,7.265,21.861,6.568z"></path>
                            </svg>
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>`;
      }
    } else {
      if (data.available == false || variantNotAvailable) {
        addToCartHtml = `<div class="product-collection__buttons d-flex flex-column flex-lg-row align-items-lg-center flex-wrap mt-5 mt-lg-10">
                      <div class="product-collection__button-add-to-cart mb-10">
                          <button type="submit" disabled="disabled" class="js-product-button-add-to-cart btn btn--full btn--animated ${boostPFSConfig.custom.animation_enabled
            ? "btn--animation-shake"
            : ""
          }">
                              <span class="d-flex flex-center"> Out of stock </span>
                          </button>
                      </div>
                      <div class="product-collection__buttons-section d-flex px-lg-10">
                        <div class="product-collection__button-add-to-wishlist mb-10">
                          <a href="/account" class="btn btn--text btn--status px-lg-6 js-store-lists-add-wishlist">
                            <i class="mb-1 ml-1">
                              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
                                <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                          s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                          c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                          s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                          s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                          c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                          S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
                          c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
                          c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
                          c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
                          c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
                          s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
                          S20.552,9.968,20.324,10.515z"></path>
                              </svg>
                            </i>
                            <i class="mb-1 ml-1" data-button-content="added">
                              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
                                <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
                          s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
                          c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
                          s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
                          s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
                          c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
                          S22.147,7.265,21.861,6.568z"></path>
                              </svg>
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>`;
      }
    }
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, addToCartHtml);

    var ProductBadges = "";
    var MainProductHeadline = Utils.getProductMetafield(
      data,
      "ProductHeadline",
      "ProductHeadline"
    );
    var MainProductBadgesColor = Utils.getProductMetafield(
      data,
      "ProductBadgesColor",
      "ProductBadgesColor"
    );
    var MainProductBadgesText = Utils.getProductMetafield(
      data,
      "ProductBadgesText",
      "ProductBadgesText"
    );
    if (
      MainProductBadgesText == null ||
      MainProductBadgesText == "" ||
      MainProductBadgesText == undefined
    ) {
      ProductBadges = "";
    } else {
      ProductBadges =
        '<div class="ProductBadges" style="background: ' +
        MainProductBadgesColor +
        "; border-top-color: " +
        MainProductBadgesColor +
        "; border-left-color: " +
        MainProductBadgesColor +
        ';">' +
        "<span>" +
        MainProductBadgesText +
        "</span>" +
        "</div>";
    }
    itemHtml = itemHtml.replace(/{{ProductBadges}}/g, ProductBadges);

      //  Custom discount
      let customDiscount = Utils.getProductMetafield(data, "discountTag", "discountTag");

      // Boost-560158: Tag-based discount logic
      if (data.tags.includes("Free-Delivery")) {
        customDiscount = boostPFSAppConfig?.discount_collection_text || '';
      } else {
        // Define tag-based discounts in a map
        const tagDiscountMap = new Map([
          ["5percentoff", '<p><strong>Get 5% off</strong> (Limited Promotion)</p>'],
          ["11percentoff", '<p><strong>Get 11% off &amp; Free Assembly &amp; Installation</strong> (DFW Only)</p>'],
          ["500coupon", '<p><strong>Get $500.00 Off</strong></p>'],
          ["100coupon", '<p><strong>Get $100.00 Off</strong></p>']
        ]);
      
        // Find and apply the first matching tag from the map
        for (const [tag, message] of tagDiscountMap) {
          if (data.tags.includes(tag)) {
            customDiscount = message;
            break;
          }
        }
      
        // Clear if no matching tag and metafield is empty
        if (!customDiscount) {
          customDiscount = '';
        }
      }


      

      /* Boost-560158 */
     itemHtml = itemHtml.replace(/{{customDiscount}}/g, customDiscount);

    // Start Boost 161717
    itemHtml = itemHtml.replace(
      /{{collectionId}}/g,
      boostPFSConfig.general.collection_id
    );
    // End Boost 161717

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, unescapeSlashes(data.title));
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    itemHtml = itemHtml.replace(/{{itemJson}}/g, buildItemJson(data));

    if (window.innerWidth > 1024 && window.innerWidth < 1260) {
      if (index == 1 && typeof truw_know_how !== "undefined") {
        itemHtml += truw_know_how;
      }
      if (index == 3 && typeof faqCollection !== "undefined") {
        itemHtml += faqCollection;
        if (
          typeof four_slot_link !== "undefined" &&
          four_slot_link.length > 10
        ) {
          itemHtml += proHtml;
          itemHtml = itemHtml.replace(/{{fourthLink}}/g, four_slot_link);
          itemHtml = itemHtml.replace(/{{fourthImage}}/g, four_slot_Image);
        }
      }
      if (
        index == 5 &&
        typeof firstBanner !== "undefined" &&
        four_slot_link.length < 10
      ) {
        itemHtml += firstBanner;
      } else if (
        index == 4 &&
        typeof firstBanner !== "undefined" &&
        typeof four_slot_link !== "undefined" &&
        four_slot_link.length > 10
      ) {
        itemHtml += firstBanner;
      }
      if (
        index == 7 &&
        typeof secondBanner !== "undefined" &&
        four_slot_link.length < 10
      ) {
        itemHtml += secondBanner;
      } else if (
        index == 6 &&
        typeof secondBanner !== "undefined" &&
        typeof four_slot_link !== "undefined" &&
        four_slot_link.length > 10
      ) {
        itemHtml += firstBanner;
      }
    } else {
      /* Start-Boost-161717 */
      if (collectionArr.includes(boostPFSAppConfig.general.collection_handle)) {
        if (index == 3 && typeof truw_know_how !== "undefined") {
          itemHtml += truw_know_how;
          if (four_slot_link.length > 10) {
            itemHtml += proHtml;
            itemHtml = itemHtml.replace(/{{fourthLink}}/g, four_slot_link);
            itemHtml = itemHtml.replace(/{{fourthImage}}/g, four_slot_Image);
          }
        }
        if (
          index == 7 &&
          typeof faqCollection !== "undefined" &&
          four_slot_link.length < 10
        ) {
          itemHtml += faqCollection;
        } else if (
          index == 6 &&
          typeof faqCollection !== "undefined" &&
          four_slot_link.length > 10
        ) {
          itemHtml += faqCollection;
        }
        if (
          index == 11 &&
          typeof firstBanner !== "undefined" &&
          four_slot_link.length < 10
        ) {
          itemHtml += firstBanner;
        } else if (
          index == 10 &&
          typeof faqCollection !== "undefined" &&
          four_slot_link.length > 10
        ) {
          itemHtml += firstBanner;
        }
        if (
          index == 14 &&
          typeof secondBanner !== "undefined" &&
          four_slot_link.length < 10
        ) {
          itemHtml += secondBanner;
        } else if (
          index == 14 &&
          typeof faqCollection !== "undefined" &&
          four_slot_link.length > 10
        ) {
          itemHtml += secondBanner;
        }
      } else {
        if (index == 2 && typeof truw_know_how !== "undefined") {
          itemHtml += truw_know_how;
          if (
            typeof four_slot_link !== "undefined" &&
            four_slot_link.length > 10
          ) {
            itemHtml += proHtml;
            itemHtml = itemHtml.replace(/{{fourthLink}}/g, four_slot_link);
            itemHtml = itemHtml.replace(/{{fourthImage}}/g, four_slot_Image);
          }
        }
        if (
          index == 5 &&
          typeof faqCollection !== "undefined" &&
          four_slot_link.length < 10
        ) {
          itemHtml += faqCollection;
        } else if (
          index == 4 &&
          typeof faqCollection !== "undefined" &&
          typeof four_slot_link !== "undefined" &&
          four_slot_link.length > 10
        ) {
          itemHtml += faqCollection;
        }
        if (
          index == 8 &&
          typeof firstBanner !== "undefined" &&
          four_slot_link.length < 10
        ) {
          itemHtml += firstBanner;
        } else if (
          index == 7 &&
          typeof faqCollection !== "undefined" &&
          typeof four_slot_link !== "undefined" &&
          four_slot_link.length > 10
        ) {
          itemHtml += firstBanner;
        }
        if (
          index == 11 &&
          typeof secondBanner !== "undefined" &&
          four_slot_link.length < 10
        ) {
          itemHtml += secondBanner;
        } else if (
          index == 10 &&
          typeof faqCollection !== "undefined" &&
          typeof four_slot_link !== "undefined" &&
          four_slot_link.length > 10
        ) {
        }
      }
      /* End-Boost-161717 */
      // if(index == 2 && typeof(truw_know_how) !== 'undefined'){
      //   itemHtml += truw_know_how;
      //   if(typeof four_slot_link !== 'undefined' && four_slot_link.length > 10) {
      //     itemHtml += proHtml;
      //     itemHtml = itemHtml.replace(/{{fourthLink}}/g, four_slot_link);
      //     itemHtml = itemHtml.replace(/{{fourthImage}}/g, four_slot_Image);
      //   };
      // }
      // if(index == 5 && typeof(faqCollection) !== 'undefined' && four_slot_link.length < 10){
      //   itemHtml += faqCollection;
      // } else if(index == 4 && typeof(faqCollection) !== 'undefined' && typeof four_slot_link !== 'undefined' && four_slot_link.length > 10) {
      //   itemHtml += faqCollection;
      // }
      // if(index == 8 && typeof(firstBanner) !== 'undefined' && four_slot_link.length < 10){
      //   itemHtml += firstBanner;
      // } else if(index == 7 && typeof(faqCollection) !== 'undefined' && typeof four_slot_link !== 'undefined' && four_slot_link.length > 10) {
      // 	itemHtml += firstBanner;
      // }
      // if(index == 11 && typeof(secondBanner) !== 'undefined'&& four_slot_link.length < 10){
      //   itemHtml += secondBanner;
      // } else if(index == 10 && typeof(faqCollection) !== 'undefined' && typeof four_slot_link !== 'undefined' && four_slot_link.length > 10) {

      // }
    }

    // Add special input
    var itemSpecialInput = "";
    var variant_pre_order = false;
    var firstAvailableVariant = data.variants.filter(function (e) {
      return e.available;
    });
    if (typeof firstAvailableVariant[0] !== "undefined") {
      if (
        firstAvailableVariant[0]["inventory_quantity"] <= -50 &&
        firstAvailableVariant[0]["inventory_policy"] == "continue"
      ) {
        variant_pre_order = true;
      }
    }
    if (variant_pre_order) {
      itemSpecialInput +=
        '<p class="line-item-property__field" style="pointer-events: none;display: none;">';
      itemSpecialInput +=
        '<input id="personalised-5-type-name-below" type="text" name="properties[Item]" value="SparksPreOrder">';
      itemSpecialInput += "</p>";
    }
    itemHtml = itemHtml.replace(/{{itemSpecialInput}}/g, itemSpecialInput);

    return itemHtml;
  };

  // Build Product List Item
  ProductListItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;

    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    const variants = data.variants;
    const metafields = data.metafields;
    // Determine the default variant
    const defaultVariantId = determineDefaultVariant(variants, metafields);
    // Get Template
    var itemHtml = boostPFSTemplate.productListItemHtml;

    //promo
    var proHtmlMobile =
      '<div boost-pfs-item="" class="foursoltimage col-12 col-sm-6 col-md-6 col-lg-6 col-xl-12 boost-root-item">' +
      '<div class="product-collection">' +
      '<div class="product-collection__wrapper mb-30 mb-lg-30">' +
      '<a href="{{fourthLink}}">' +
      '<img src="{{fourthImage}}" loading="lazy">' +
      "</a>" +
      "</div>" +
      "</div>" +
      "</div>";
    var proHtmlListView =
      '<div boost-pfs-item="" class="foursoltimage col-12 col-sm-6 col-md-6 col-lg-6 col-xl-12 boost-root-item">' +
      '<div class="product-collection">' +
      '<div class="product-collection__wrapper mb-30 mb-lg-30">' +
      '<a href="{{fourthLink}}">' +
      '<img src="{{fourthImage}}" loading="lazy">' +
      "</a>" +
      "</div>" +
      "</div>" +
      "</div>";

    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    var saleClass = onSale ? boostPFSTemplate.saleClass : "";

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Grid Width class
    itemHtml = itemHtml.replace(
      /{{gridWidthClass}}/g,
      buildGridWidthClass(data)
    );
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add TAG Label
    itemHtml = itemHtml.replace(
      /{{itemTagLabels}}/g,
      buildTagLabels(data, false)
    );
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(
      /{{itemPrice}}/g,
      buildPrice(data, data.variants[0].id)
    );

    // Add Save Price
    itemHtml = itemHtml.replace(
      /{{itemSavePrice}}/g,
      buildSavePrice(data, data.variants[0].id, "product")
    );

    // Add Review
    if (
      typeof Integration === "undefined" ||
      (typeof Integration != "undefined" &&
        typeof Integration.hascompileTemplate == "function" &&
        !Integration.hascompileTemplate("reviews"))
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // itemActiveSwapClass
    itemHtml = itemHtml.replace(
      /{{itemActiveSwapClass}}/g,
      buildActiveSwapClass(data)
    );

    // Add Color Swatches
    itemHtml = itemHtml.replace(
      /{{itemSwatches}}/g,
      buildProductOptionSwatches(data)
    );

    // Add flooring link
    itemHtml = itemHtml.replace(/{{flooringLink}}/g, buildMySpaceLink(data));

    // itemHtml = itemHtml.replace(/{{itemDefaultVariant}}/g, data.variants[0].id);
    itemHtml = itemHtml.replace(/{{itemDefaultVariant}}/g, defaultVariantId);



    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

    var itemHeadline = Utils.getProductMetafield(
      data,
      "ProductHeadline",
      "ProductHeadline"
    );
    if (itemHeadline !== null) {
      var itemHeadlingHtml =
        '<h2 class="item-headline">' + itemHeadline + "</h2>";
      itemHtml = itemHtml.replace(/{{itemHeadline}}/g, itemHeadlingHtml);
    } else {
      itemHtml = itemHtml.replace(/{{itemHeadline}}/g, "");
    }

    // Start Boost 232076
    // Add Item On Display
    var itemDeliveryAbility = Utils.getProductMetafield(
      data,
      "Ability",
      "ability"
    );
    var itemInStock = Utils.getProductMetafield(data, "In-Stock", "In-Stock");
    var itemOnDisplay = '<div class="boost-new-info">';
    var numberInStock = 0;
    for (var i = 0; i < data.variants.length; i++) {
      numberInStock += data.variants[i].inventory_quantity;
    }
    if (
      numberInStock > 0 ||
      (itemDeliveryAbility == "true" && itemInStock == "true")
    ) {
      itemOnDisplay +=
        '<div class="boost-on-display"><img src="https://www.sparksfitness.net/cdn/shop/t/97/assets/green-check-mark.png?v=99932586340666238071679551901"><strong>On Display</strong><a href="https://www.google.com/maps/place/Sparks+Fitness+Equipment/@32.9490721,-96.8315522,17z/data=!3m1!4b1!4m5!3m4!1s0x864c21a770a2aa0f:0xf0def3e95e229103!8m2!3d32.9490721!4d-96.8293635" target="_blank"> Dallas, Texas (5.6 miles away)</a></div>';
      itemOnDisplay +=
        '<div class="boost-in-stock"><img src="https://www.sparksfitness.net/cdn/shop/t/97/assets/green-check-mark.png?v=99932586340666238071679551901"><strong>In Stock</strong><a href="https://www.google.com/maps/place/Sparks+Fitness+Equipment/@32.9490721,-96.8315522,17z/data=!3m1!4b1!4m5!3m4!1s0x864c21a770a2aa0f:0xf0def3e95e229103!8m2!3d32.9490721!4d-96.8293635" target="_blank"> Click For Store Directions</a></div>';
    } else if (itemDeliveryAbility == "true") {
      itemOnDisplay +=
        '<div class="boost-on-display"><img src="https://www.sparksfitness.net/cdn/shop/t/97/assets/green-check-mark.png?v=99932586340666238071679551901"><strong>On Display</strong><a href="https://www.google.com/maps/place/Sparks+Fitness+Equipment/@32.9490721,-96.8315522,17z/data=!3m1!4b1!4m5!3m4!1s0x864c21a770a2aa0f:0xf0def3e95e229103!8m2!3d32.9490721!4d-96.8293635" target="_blank"> Dallas, Texas (5.6 miles away)</a></div>';
    } else if (itemInStock == "true") {
      itemOnDisplay +=
        '<div class="boost-in-stock"><img src="https://www.sparksfitness.net/cdn/shop/t/97/assets/green-check-mark.png?v=99932586340666238071679551901"><strong>In Stock</strong><a href="https://www.google.com/maps/place/Sparks+Fitness+Equipment/@32.9490721,-96.8315522,17z/data=!3m1!4b1!4m5!3m4!1s0x864c21a770a2aa0f:0xf0def3e95e229103!8m2!3d32.9490721!4d-96.8293635" target="_blank"> Click For Store Directions</a></div>';
    }
    itemOnDisplay += "</div>";
    itemHtml = itemHtml.replace(/{{itemOnDisplay}}/g, itemOnDisplay);
    // End Boost 232076

    var itemDelivery = Utils.getProductMetafield(
      data,
      "DeliveryTimeEstimate",
      "delivery_time_estimate"
    );
    if (itemDelivery !== null) {
      var itemDeliveryHtml = '<div class="item-delivery">';
      itemDeliveryHtml += '<div class="content">';
      itemDeliveryHtml +=
        '<div class="content-desc">' + itemDelivery + "</div>";
      itemDeliveryHtml += "</div>";
      itemDeliveryHtml += "</div>";
    } else {
      var itemDeliveryHtml = '<div class="item-delivery">';
      itemDeliveryHtml += '<div class="content">';
      itemDeliveryHtml +=
        '<div class="content-desc">' +
        boostPFSThemeConfig.custom.delivery_time_estimate +
        "</div>";
      itemDeliveryHtml += "</div>";
      itemDeliveryHtml += "</div>";
    }
    itemHtml = itemHtml.replace(/{{itemExtraInfo}}/g, itemDeliveryHtml);

    var itemInstallation = Utils.getProductMetafield(
      data,
      "installation-custom",
      "installation-custom-value"
    );
    if (itemInstallation !== null) {
      var installationHtml = '<div class="installation-part part">';
      installationHtml += '<div class="part-icon">';
      installationHtml +=
        '<img src="https://cdn.shopify.com/s/files/1/0134/3275/0138/files/Installation_1_1.png?v=1648635551" style="max-width: 20px;object-fit: contain;">';
      installationHtml += "</div>";
      installationHtml += '<div class="part-content">';
      installationHtml +=
        '<div class="part-content-title">Installation: </div>';
      installationHtml +=
        '<div class="part-content-desc"><span class="green">' +
        itemInstallation +
        "</span></div>";
      installationHtml += "</div>";
      installationHtml += "</div>";
      itemHtml = itemHtml.replace(/{{itemInstallation}}/g, installationHtml);
    } else {
      var installationHtml = '<div class="installation-part part">';
      installationHtml += '<div class="part-icon">';
      installationHtml +=
        '<img src="https://cdn.shopify.com/s/files/1/0134/3275/0138/files/Installation_1_1.png?v=1648635551" style="max-width: 20px;object-fit: contain;">';
      installationHtml += "</div>";
      installationHtml += '<div class="part-content">';
      installationHtml +=
        '<div class="part-content-title">Installation: </div>';
      installationHtml +=
        '<div class="part-content-desc"><span class="green">In 3 Days</span></div>';
      installationHtml += "</div>";
      installationHtml += "</div>";
      itemHtml = itemHtml.replace(/{{itemInstallation}}/g, installationHtml);
    }

    var metafield = data.metafields.filter(
      (e) => e.namespace === "Home_delivery"
    );
    if (metafield.length != 0) {
      var valueMetafield = metafield[0].value;
    } else {
    }

    var itemDeliveryHtml = '<div class="free-delivery-part part">';
    itemDeliveryHtml += '<div class="part-icon">';
    itemDeliveryHtml +=
      '<svg aria-hidden="true" role="img" viewBox="0 0 100 100" style="fill:#1D252C;width:20px;height:20px;margin-right:6px"><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><svg id="Delivery_Line_Sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M29.552 17.247h-.521l-2.56-5.197a.979.979 0 00-.877-.546h-4.05V4.77a.978.978 0 00-.978-.978H4.026a.978.978 0 00-.978.978v2.148a.978.978 0 001.955 0v-1.17H19.59V17.23H5.003v-.5a.978.978 0 00-1.955 0v5.668a2.431 2.431 0 002.428 2.428h.797a3.534 3.534 0 003.523 3.381 3.534 3.534 0 003.523-3.381H22.253c.084 1.877 1.624 3.381 3.522 3.381s3.44-1.504 3.523-3.381h.254A2.45 2.45 0 0032 22.38v-2.685a2.45 2.45 0 00-2.448-2.448zM9.796 26.254a1.585 1.585 0 010-3.166c.873 0 1.583.71 1.583 1.582 0 .874-.71 1.584-1.583 1.584zm15.979 0a1.585 1.585 0 111.584-1.583c0 .873-.71 1.583-1.584 1.583zm4.27-3.874c0 .27-.221.492-.493.492h-.747c-.617-1.036-1.738-1.74-3.03-1.74s-2.412.704-3.03 1.74h-9.919a3.528 3.528 0 00-3.03-1.74 3.527 3.527 0 00-3.03 1.74h-1.29a.474.474 0 01-.473-.473v-3.213h15.563c.005 0 .01-.003.014-.003.033.003.062.02.096.02.54 0 .977-.438.977-.978V13.46h3.333l2.559 5.197a.978.978 0 00.877.545h1.13c.272 0 .493.221.493.493v2.685z"></path><path d="M8.98 13.44a.978.978 0 00-.978-.975h-.003l-7.024.02a.978.978 0 00.003 1.955H.98l7.024-.02a.978.978 0 00.976-.98zM3.994 11.153l4.02-.007a.978.978 0 00-.001-1.955H8.01l-4.02.007a.978.978 0 000 1.955h.003z"></path></svg></svg></svg>';
    itemDeliveryHtml += "</div>";
    itemDeliveryHtml += '<div class="part-content">';
    itemDeliveryHtml +=
      '<div class="part-content-title">Delivery or Installation: </div>';
    if (metafield.length != 0) {
      var valueMetafield = metafield[0].value;
      itemDeliveryHtml +=
        '<div class="part-content-desc"><span style="color:#040c13"><span>' +
        valueMetafield +
        "</span></span></div>";
    } else {
      itemDeliveryHtml +=
        '<div class="part-content-desc"><span style="color:#040c13" id="DeliveryDate"><span></span></span></div>';
    }
    itemDeliveryHtml += "</div>";
    itemDeliveryHtml += "</div>";
    itemHtml = itemHtml.replace(/{{itemDelivery}}/g, itemDeliveryHtml);

    var itemPickup = Utils.getProductMetafield(
      data,
      "delivery-pickup-valu",
      "delivery-pickup-value"
    );
    if (itemPickup !== null) {
      var itemPickupyHtml = '<div class="pickup-part part">';
      itemPickupyHtml += '<div class="part-icon">';
      itemPickupyHtml +=
        '<svg aria-hidden="true" role="img" viewBox="0 0 100 100" style="fill:#1D252C;width:20px;height:20px;margin-right:6px"><svg id="Store_Line_Sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xml:space="preserve"><path d="M28.9 11.92h-3.78a.98.98 0 0 0 0 1.96h3.79c.14 0 .25.12.25.25V28c0 .14-.11.26-.25.26h-5.03v-4.6c0-.84-.68-1.52-1.52-1.52h-9.72c-.82 0-1.44.65-1.44 1.52v4.6H6.24a.27.27 0 0 1-.27-.27V16.47h15.7c.54 0 .98-.44.98-.98V2.84a.98.98 0 0 0-.98-.97H5.8c-.25 0-.49.1-.67.26L1.2 5.85c-.2.19-.3.45-.3.72v5.1c0 .26.1.51.3.7l2.84 2.77c0 .05-.03.09-.03.14v12.7c0 1.23 1 2.23 2.23 2.23H28.9c1.22 0 2.2-1 2.2-2.21V14.13a2.2 2.2 0 0 0-2.2-2.2zM2.86 7 6.2 3.82h14.5v10.69H6.2l-3.35-3.26V7zm19.08 21.27h-3.48V24.1h3.48v4.16zm-8.78-4.16h3.34v4.16h-3.34V24.1zM6.38 9.06a.98.98 0 0 1-1.96 0c0-.54.45-.98.98-.98.55 0 .98.44.98.98z"></path></svg></svg>';
      itemPickupyHtml += "</div>";
      itemPickupyHtml += '<div class="part-content">';
      itemPickupyHtml +=
        '<div class="part-content-title">Free In-Store Pickup: </div>';
      itemPickupyHtml += '<div class="part-content-desc">';
      // itemPickupyHtml += '<div>' + boostPFSThemeConfig.custom.delivery_pickup_value + '</div>';
      itemPickupyHtml +=
        '<div><span class="green"><a href="https://maps.google.com/maps?ll=32.949072,-96.829363&z=15&t=m&hl=en&gl=IN&mapclient=embed&cid=17356578197564723459" target="_blank" style="text-align:left">Get Store Directions</a></span></div>';
      itemPickupyHtml += "</div>";
      itemPickupyHtml += "</div>";
      itemPickupyHtml += "</div>";
      itemHtml = itemHtml.replace(/{{itemPickup}}/g, itemPickupyHtml);
    } else {
      var itemPickupyHtml = '<div class="pickup-part part">';
      itemPickupyHtml += '<div class="part-icon">';
      itemPickupyHtml +=
        '<svg aria-hidden="true" role="img" viewBox="0 0 100 100" style="fill:#1D252C;width:20px;height:20px;margin-right:6px"><svg id="Store_Line_Sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xml:space="preserve"><path d="M28.9 11.92h-3.78a.98.98 0 0 0 0 1.96h3.79c.14 0 .25.12.25.25V28c0 .14-.11.26-.25.26h-5.03v-4.6c0-.84-.68-1.52-1.52-1.52h-9.72c-.82 0-1.44.65-1.44 1.52v4.6H6.24a.27.27 0 0 1-.27-.27V16.47h15.7c.54 0 .98-.44.98-.98V2.84a.98.98 0 0 0-.98-.97H5.8c-.25 0-.49.1-.67.26L1.2 5.85c-.2.19-.3.45-.3.72v5.1c0 .26.1.51.3.7l2.84 2.77c0 .05-.03.09-.03.14v12.7c0 1.23 1 2.23 2.23 2.23H28.9c1.22 0 2.2-1 2.2-2.21V14.13a2.2 2.2 0 0 0-2.2-2.2zM2.86 7 6.2 3.82h14.5v10.69H6.2l-3.35-3.26V7zm19.08 21.27h-3.48V24.1h3.48v4.16zm-8.78-4.16h3.34v4.16h-3.34V24.1zM6.38 9.06a.98.98 0 0 1-1.96 0c0-.54.45-.98.98-.98.55 0 .98.44.98.98z"></path></svg></svg>';
      itemPickupyHtml += "</div>";
      itemPickupyHtml += '<div class="part-content">';
      itemPickupyHtml +=
        '<div class="part-content-title">Free In-Store Pickup:</div>';
      itemPickupyHtml += '<div class="part-content-desc">';
      // itemPickupyHtml += '<div>' + boostPFSThemeConfig.custom.delivery_pickup_value + '</div>';
      itemPickupyHtml +=
        '<div><span class="green"><a href="https://maps.google.com/maps?ll=32.949072,-96.829363&z=15&t=m&hl=en&gl=IN&mapclient=embed&cid=17356578197564723459" target="_blank" style="text-align:left">Get Store Directions</a></span></div>';
      itemPickupyHtml += "</div>";
      itemPickupyHtml += "</div>";
      itemPickupyHtml += "</div>";
      itemHtml = itemHtml.replace(/{{itemPickup}}/g, itemPickupyHtml);
    }

    var ProductBadges = "";
    var MainProductHeadline = Utils.getProductMetafield(
      data,
      "ProductHeadline",
      "ProductHeadline"
    );
    var MainProductBadgesColor = Utils.getProductMetafield(
      data,
      "ProductBadgesColor",
      "ProductBadgesColor"
    );
    var MainProductBadgesText = Utils.getProductMetafield(
      data,
      "ProductBadgesText",
      "ProductBadgesText"
    );
    if (
      MainProductBadgesText == null ||
      MainProductBadgesText == "" ||
      MainProductBadgesText == undefined
    ) {
      ProductBadges = "";
    } else {
      ProductBadges =
        '<div class="ProductBadges" style="background: ' +
        MainProductBadgesColor +
        "; border-top-color: " +
        MainProductBadgesColor +
        "; border-left-color: " +
        MainProductBadgesColor +
        ';">' +
        "<span>" +
        MainProductBadgesText +
        "</span>" +
        "</div>";
    }
    itemHtml = itemHtml.replace(/{{ProductBadges}}/g, ProductBadges);

      let customDiscount = Utils.getProductMetafield(data, "discountTag", "discountTag");

      // Boost-560158: Tag-based discount logic
      if (data.tags.includes("Free-Delivery")) {
        customDiscount = boostPFSAppConfig?.discount_collection_text || '';
      } else {
        // Define tag-based discounts in a map
        const tagDiscountMap = new Map([
          ["5percentoff", '<p><strong>Get 5% off</strong> (Limited Promotion)</p>'],
          ["11percentoff", '<p><strong>Get 11% off &amp; Free Assembly &amp; Installation</strong> (DFW Only)</p>'],
          ["500coupon", '<p><strong>Get $500.00 Off</strong></p>'],
          ["100coupon", '<p><strong>Get $100.00 Off</strong></p>']
        ]);
      
        // Find and apply the first matching tag from the map
        for (const [tag, message] of tagDiscountMap) {
          if (data.tags.includes(tag)) {
            customDiscount = message;
            break;
          }
        }
      
        // Clear if no matching tag and metafield is empty
        if (!customDiscount) {
          customDiscount = '';
        }
      }


  /* Boost-560158 */
     itemHtml = itemHtml.replace(/{{customDiscount}}/g, customDiscount);

    var itemAvailableHtml =
      '<div class="confirm-availability-btn btn-link h6 d-flex align-items-center mb-10 js-popup-button" id="confrim-availability-' +
      data.id +
      '" data-js-popup-button="confirm-availability" data-js-popup-dynamic-content="test">';
    itemAvailableHtml += "<span>Confirm Availability</span>";
    itemAvailableHtml += "</div>";
    itemHtml = itemHtml.replace(/{{itemAvailable}}/g, itemAvailableHtml);

    var addToCartHtml = "";
    var variantNotAvailable = data.variants.filter(function (e) {
      return e.available == false;
    });
    if (data.available) {
      var accordionMetafield = Utils.getProductMetafield(
        data,
        "AccordionTitle",
        "AccordionTitle"
      );
      var priceMetafield = Utils.getProductMetafield(
        data,
        "hide-add-to-cart",
        "hide-add-to-cart"
      );
      if (accordionMetafield) {
        addToCartHtml = `<div class="product-collection__list-v2-button-add-to-cart mt-25">
                    	<a href="{{itemUrl}}" class="btn">View Detail</a>
                    </div>
                    <div class="product-collection__list-v2-buttons d-flex flex-column align-items-end pt-3 mt-15"><div class="product-collection__list-v2-button-add-to-wishlist"><a href="/account" class="btn btn--text btn--status px-md-0 js-store-lists-add-wishlist">
        <span class="d-flex flex-center"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
    <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
    	c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
    	c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
    	c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
    	c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
    	s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
    	S20.552,9.968,20.324,10.515z"></path>
    </svg>
    </i>Add To Wishlist</span>
        <span class="d-flex flex-center" data-button-content="added"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
    <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S22.147,7.265,21.861,6.568z"></path>
    </svg>
    </i>Added To Wishlist</span>
    </a>
    </div>
    </div>`;
      } else if (data.template_suffix == "requires-contact") {
        addToCartHtml = `<div class="product-collection__list-v2-button-add-to-cart mt-25">
                    	<a href="/pages/store-locator" class="btn order_from_store_btn">Order from store</a>
                    </div>
                    <div class="product-collection__list-v2-buttons d-flex flex-column align-items-end pt-3 mt-15"><div class="product-collection__list-v2-button-add-to-wishlist"><a href="/account" class="btn btn--text btn--status px-md-0 js-store-lists-add-wishlist">
        <span class="d-flex flex-center"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
    <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
    	c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
    	c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
    	c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
    	c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
    	s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
    	S20.552,9.968,20.324,10.515z"></path>
    </svg>
    </i>Add To Wishlist</span>
        <span class="d-flex flex-center" data-button-content="added"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
    <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S22.147,7.265,21.861,6.568z"></path>
    </svg>
    </i>Added To Wishlist</span>
    </a>
    </div>
    </div>`;
      } else if (
        firstVariant.inventory_quantity <= -50 &&
        firstVariant.inventory_policy == "continue"
      ) {
        addToCartHtml = `<div class="product-collection__list-v2-button-add-to-cart mt-25">
                    	<button type="submit" class="cp-add-to-cart js-product-button-add-to-cart btn btn--full btn--animated">
                            <span class="d-flex flex-center"> Pre Order </span>
                        </button>
                    </div>
                    <div class="product-collection__list-v2-buttons d-flex flex-column align-items-end pt-3 mt-15"><div class="product-collection__list-v2-button-add-to-wishlist"><a href="/account" class="btn btn--text btn--status px-md-0 js-store-lists-add-wishlist">
        <span class="d-flex flex-center"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
    <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
    	c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
    	c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
    	c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
    	c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
    	s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
    	S20.552,9.968,20.324,10.515z"></path>
    </svg>
    </i>Add To Wishlist</span>
        <span class="d-flex flex-center" data-button-content="added"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
    <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S22.147,7.265,21.861,6.568z"></path>
    </svg>
    </i>Added To Wishlist</span>
    </a>
    </div>
    </div>`;
      } else if (
        priceMetafield == "true" ||
        data.tags.indexOf("price_hidden") !== -1
      ) {
        addToCartHtml = `<div class="product-collection__list-v2-button-add-to-cart mt-25">
                    	<a href="/pages/store-locator" class="btn order_from_store_btn">Order from store</a>
                    </div>
                    <div class="product-collection__list-v2-buttons d-flex flex-column align-items-end pt-3 mt-15"><div class="product-collection__list-v2-button-add-to-wishlist"><a href="/account" class="btn btn--text btn--status px-md-0 js-store-lists-add-wishlist">
        <span class="d-flex flex-center"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
    <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
    	c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
    	c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
    	c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
    	c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
    	s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
    	S20.552,9.968,20.324,10.515z"></path>
    </svg>
    </i>Add To Wishlist</span>
        <span class="d-flex flex-center" data-button-content="added"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
    <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S22.147,7.265,21.861,6.568z"></path>
    </svg>
    </i>Added To Wishlist</span>
    </a>
    </div>
    </div>`;
      } else {
        addToCartHtml = `<div class="product-collection__list-v2-button-add-to-cart mt-25">
                    	<button type="submit" class="cp-add-to-cart js-product-button-add-to-cart btn btn--full btn--animated">
                            <span class="d-flex flex-center add-to-cart-text"> Add to cart </span>
                        </button>
                    </div>
                    <div class="product-collection__list-v2-buttons d-flex flex-column align-items-end pt-3 mt-15"><div class="product-collection__list-v2-button-add-to-wishlist"><a href="/account" class="btn btn--text btn--status px-md-0 js-store-lists-add-wishlist">
        <span class="d-flex flex-center"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
    <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
    	c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
    	c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
    	c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
    	c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
    	s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
    	S20.552,9.968,20.324,10.515z"></path>
    </svg>
    </i>Add To Wishlist</span>
        <span class="d-flex flex-center" data-button-content="added"><i class="mr-5 mb-1">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
    <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
    	s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
    	c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
    	s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
    	s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
    	c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
    	S22.147,7.265,21.861,6.568z"></path>
    </svg>
    </i>Added To Wishlist</span>
    </a>
    </div>
    </div>`;
      }
    } else {
      if (data.available == false || variantNotAvailable) {
        addToCartHtml = `<div class="product-collection__list-v2-button-add-to-cart mt-25">
                          <button disabled type="submit" class="js-product-button-add-to-cart btn btn--full btn--animated">
                              <span class="d-flex flex-center"> Out of stock </span>
                          </button>
                      </div>
                      <div class="product-collection__list-v2-buttons d-flex flex-column align-items-end pt-3 mt-15"><div class="product-collection__list-v2-button-add-to-wishlist"><a href="/account" class="btn btn--text btn--status px-md-0 js-store-lists-add-wishlist">
          <span class="d-flex flex-center"><i class="mr-5 mb-1">
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
      <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
          s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
          c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
          s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
          s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
          c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
          S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
          c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
          c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
          c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
          c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
          s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
          S20.552,9.968,20.324,10.515z"></path>
      </svg>
      </i>Add To Wishlist</span>
          <span class="d-flex flex-center" data-button-content="added"><i class="mr-5 mb-1">
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
      <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
          s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
          c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
          s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
          s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
          c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
          S22.147,7.265,21.861,6.568z"></path>
      </svg>
      </i>Added To Wishlist</span>
      </a>
      </div>
      </div>`;
      }
      //       addToCartHtml = `<div class="product-collection__list-v2-button-add-to-cart mt-25">
      //                     <button disabled type="submit" class="js-product-button-add-to-cart btn btn--full btn--animated">
      //                         <span class="d-flex flex-center"> Out of stock </span>
      //                     </button>
      //                 </div>
      //                 <div class="product-collection__list-v2-buttons d-flex flex-column align-items-end pt-3 mt-15"><div class="product-collection__list-v2-button-add-to-wishlist"><a href="/account" class="btn btn--text btn--status px-md-0 js-store-lists-add-wishlist">
      //     <span class="d-flex flex-center"><i class="mr-5 mb-1">
      // <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-180" viewBox="0 0 24 24">
      // <path d="M21.486,6.599c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
      //     s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
      //     c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
      //     s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.049,5.28,2.632,5.902,2.346,6.599s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
      //     s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
      //     c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
      //     S21.772,7.295,21.486,6.599z M20.324,10.515c-0.228,0.547-0.55,1.028-0.967,1.445l-7.441,7.441L4.475,11.96
      //     c-0.417-0.417-0.739-0.898-0.967-1.445s-0.342-1.12-0.342-1.719S3.28,7.624,3.508,7.077s0.55-1.035,0.967-1.465
      //     c0.442-0.43,0.94-0.755,1.494-0.977s1.116-0.332,1.689-0.332s1.136,0.11,1.689,0.332s1.045,0.547,1.475,0.977
      //     c0.104,0.104,0.205,0.215,0.303,0.332s0.186,0.241,0.264,0.371c0.117,0.169,0.293,0.254,0.527,0.254s0.41-0.085,0.527-0.254
      //     c0.078-0.13,0.166-0.254,0.264-0.371s0.198-0.228,0.303-0.332c0.43-0.43,0.921-0.755,1.475-0.977s1.116-0.332,1.689-0.332
      //     s1.136,0.11,1.689,0.332s1.052,0.547,1.494,0.977c0.417,0.43,0.739,0.918,0.967,1.465s0.342,1.12,0.342,1.719
      //     S20.552,9.968,20.324,10.515z"></path>
      // </svg>
      // </i>Add To Wishlist</span>
      //     <span class="d-flex flex-center" data-button-content="added"><i class="mr-5 mb-1">
      // <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-181" viewBox="0 0 24 24">
      // <path d="M21.861,6.568c-0.286-0.696-0.703-1.318-1.25-1.865c-0.56-0.56-1.191-0.979-1.895-1.26s-1.423-0.42-2.158-0.42
      //     s-1.458,0.14-2.168,0.42s-1.345,0.7-1.904,1.26c-0.026,0.039-0.056,0.075-0.088,0.107s-0.068,0.068-0.107,0.107
      //     c-0.039-0.039-0.075-0.075-0.107-0.107s-0.062-0.068-0.088-0.107c-0.56-0.56-1.194-0.979-1.904-1.26s-1.433-0.42-2.168-0.42
      //     s-1.455,0.14-2.158,0.42s-1.335,0.7-1.895,1.26C3.424,5.25,3.007,5.872,2.721,6.568s-0.43,1.429-0.43,2.197s0.144,1.501,0.43,2.197
      //     s0.703,1.318,1.25,1.865l7.871,7.871c0.003,0.003,0.007,0.004,0.011,0.006l0.439,0.436l0.439-0.437
      //     c0.003-0.002,0.007-0.003,0.01-0.006l7.871-7.871c0.547-0.547,0.964-1.169,1.25-1.865s0.43-1.429,0.43-2.197
      //     S22.147,7.265,21.861,6.568z"></path>
      // </svg>
      // </i>Added To Wishlist</span>
      // </a>
      // </div>
      // </div>`;
    }
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, addToCartHtml);

    itemHtml = itemHtml.replace(/{{itemTitle}}/g, unescapeSlashes(data.title));
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    itemHtml = itemHtml.replace(/{{itemJson}}/g, buildItemJson(data));

    if (window.innerWidth > 1024) {
      if (index == 0 && typeof truw_know_how !== "undefined") {
        itemHtml += truw_know_how;
      }
      if (index == 2 && typeof faqCollection !== "undefined") {
        itemHtml += faqCollection;
        if (
          typeof four_slot_link !== "undefined" &&
          four_slot_link.length > 10
        ) {
          itemHtml += proHtmlListView;
          itemHtml = itemHtml.replace(/{{fourthLink}}/g, four_slot_link);
          itemHtml = itemHtml.replace(/{{fourthImage}}/g, list_four_slot_Image);
        }
      }
      if (
        index == 4 &&
        typeof firstBanner !== "undefined" &&
        four_slot_link.length < 10
      ) {
        itemHtml += firstBanner;
      } else if (
        index == 3 &&
        typeof firstBanner !== "undefined" &&
        typeof four_slot_link !== "undefined" &&
        four_slot_link.length > 10
      ) {
        itemHtml += firstBanner;
      }
      if (
        index == 6 &&
        typeof secondBanner !== "undefined" &&
        four_slot_link.length < 10
      ) {
        itemHtml += secondBanner;
      } else if (
        index == 5 &&
        typeof secondBanner !== "undefined" &&
        typeof four_slot_link !== "undefined" &&
        four_slot_link.length > 10
      ) {
        itemHtml += secondBanner;
      }
    } else {
      if (index == 1 && typeof truw_know_how !== "undefined") {
        itemHtml += truw_know_how;
      }
      if (index == 2) {
        if (
          typeof four_slot_link !== "undefined" &&
          four_slot_link.length > 10
        ) {
          itemHtml += proHtmlMobile;
          itemHtml = itemHtml.replace(/{{fourthLink}}/g, four_slot_link);
          itemHtml = itemHtml.replace(/{{fourthImage}}/g, four_slot_Image);
        }
      }
      if (
        index == 3 &&
        typeof faqCollection !== "undefined" &&
        four_slot_link.length < 10
      ) {
        itemHtml += faqCollection;
      } else if (
        index == 2 &&
        typeof faqCollection !== "undefined" &&
        typeof four_slot_link !== "undefined" &&
        four_slot_link.length > 10
      ) {
        itemHtml += faqCollection;
      }

      if (
        index == 5 &&
        typeof firstBanner !== "undefined" &&
        four_slot_link.length < 10
      ) {
        itemHtml += firstBanner;
      } else if (
        index == 4 &&
        typeof firstBanner !== "undefined" &&
        typeof four_slot_link !== "undefined" &&
        four_slot_link.length > 10
      ) {
        itemHtml += firstBanner;
      }

      if (
        index == 7 &&
        typeof secondBanner !== "undefined" &&
        four_slot_link.length < 10
      ) {
        itemHtml += secondBanner;
      } else if (
        index == 6 &&
        typeof secondBanner !== "undefined" &&
        typeof four_slot_link !== "undefined" &&
        four_slot_link.length > 10
      ) {
        itemHtml += secondBanner;
      }
    }

    // Add special input
    var itemSpecialInput = "";
    var variant_pre_order = false;
    var firstAvailableVariant = data.variants.filter(function (e) {
      return e.available;
    });
    if (typeof firstAvailableVariant[0] !== "undefined") {
      if (
        firstAvailableVariant[0]["inventory_quantity"] <= -50 &&
        firstAvailableVariant[0]["inventory_policy"] == "continue"
      ) {
        variant_pre_order = true;
      }
    }
    if (variant_pre_order) {
      itemSpecialInput +=
        '<p class="line-item-property__field" style="pointer-events: none;display: none;">';
      itemSpecialInput +=
        '<input id="personalised-5-type-name-below" type="text" name="properties[Item]" value="SparksPreOrder">';
      itemSpecialInput += "</p>";
    }
    itemHtml = itemHtml.replace(/{{itemSpecialInput}}/g, itemSpecialInput);

    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/

  function buildMySpaceLink(data) {
    var html = "";
    var isFlooringCollection =
      boostPFSConfig.general.collection_handle == "rubber-flooring-turf";
    if (isFlooringCollection) {
      html += '<div class="see_in_space">';
      html +=
        '<a href="https://www.sparksfitness.net/pages/flooring-visualizer/" target="_blank">See this in my space <br /><span>Free Visualizer</span></a>';
      html += "</div>";
    }
    return html;
  }

  function buildItemJson(data) {
    var itemJSON = data;
    itemJSON.description = "";
    itemJSON.body_html = "";
    itemJSON.tags = [];
    itemJSON.title = "";
    return JSON.stringify(itemJSON);
  }

  function addslashes(string) {
    return string
      .replace(/\\/g, "\\\\")
      .replace(/\u0008/g, "\\b")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\f/g, "\\f")
      .replace(/\r/g, "\\r")
      .replace(/'/g, "\\'")
      .replace(/"/g, '\\"');
  }

  function unescapeSlashes(str) {
    return str.replace(/\\/g, "");
  }

  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildGridWidthClass() {
    var gridWidthClass = "";
    // On PC
    switch (boostPFSThemeConfig.custom.products_per_row) {
      case 2:
        gridWidthClass = "boost-pfs-filter-grid-width-2";
        break;
      case 3:
        gridWidthClass = "boost-pfs-filter-grid-width-3";
        break;
      case 5:
        gridWidthClass = "boost-pfs-filter-grid-width-5";
        break;
      case 6:
        gridWidthClass = "boost-pfs-filter-grid-width-6";
        break;
      default:
        gridWidthClass = "boost-pfs-filter-grid-width-4";
        break;
    }
    // On Mobile
    switch (boostPFSThemeConfig.custom.products_per_row_m) {
      case 1:
        gridWidthClass += " boost-pfs-filter-grid-width-mb-1";
        break;
      case 3:
        gridWidthClass += " boost-pfs-filter-grid-width-mb-3";
        break;
      default:
        gridWidthClass += " boost-pfs-filter-grid-width-mb-2";
        break;
    }
    return gridWidthClass;
  }

  function buildImages(data) {
  // console.log('buildImages', data);
  // console.log('mobile', Utils.isMobile());
  

  if (Utils.isMobile()) {
  var html = "",
    imgAlt = data.title,
    // itemUrl = data.url, // Assuming this is the product link
    imagesArr = Object.values(images);

  const totalImages = imagesArr.length;

  if (totalImages > 1) {
    html += '<div class="mobile-slick-slider">';

    const maxImages = Math.min(totalImages, 5);
    for (var i = 0; i < maxImages; i++) {
      html += '<a href="{{itemUrl}}" class="">';
      html += '<img src="' + imagesArr[i].src + '" alt="' + imgAlt + '" class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad" />';
      html += '</a>';
    }

    html += '</div>';
  } else if (totalImages === 1) {
    // Just one image: no slider
    html += '<a href="{{itemUrl}}" class="">';
    html += '<img src="' + imagesArr[0].src + '" alt="' + imgAlt + '" class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad" />';
    html += '</a>';
  }
}


 else {
    var html = "",
      aspectRatio = "",
      rangeWidths = boostPFSRangeWidths,
      paddingTop = 100;

    var dataSrcSet = "",
      dataWidths = "",
      dataSizes = "auto",
      imgAlt = data.title,
      flipImageSrcSet = "";

    var activeSwapImage = !Utils.isMobile() && images.length > 1;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet +=
        Utils.getFeaturedImage(images, rangeWidths[i] + "x") +
        " " +
        rangeWidths[i] +
        "w";
      dataWidths += rangeWidths[i];

      if (activeSwapImage) {
        flipImageSrcSet +=
          Utils.optimizeImage(images[1]["src"], rangeWidths[i] + "x") +
          " " +
          rangeWidths[i] +
          "w";
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ", ";
        dataWidths += ", ";

        if (activeSwapImage) {
          flipImageSrcSet += ", ";
        }
      }
    }

    if (images.length > 0) {
      aspectRatio = images[0]["width"] / images[0]["height"];
      paddingTop = (1 / aspectRatio) * 100;
    }

    var hasFlip = "";
    if (activeSwapImage) {
      hasFlip = "has-flip";
    }

    html +=
      '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link ' +
      hasFlip +
      '" ';
    html += 'style="padding-top:' + paddingTop + '%;">';
    html +=
      '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
      'fetchpriority="high" ' +
      'data-srcset="' +
      dataSrcSet +
      '" ' +
      'data-src="' +
      Utils.getFeaturedImage(images, rangeWidths[2] + "x") +
      '" ' +
      'data-widths="[' +
      dataWidths +
      ']" ' +
      'data-sizes="' +
      dataSizes +
      '" ' +
      'src="' +
      boostPFSImgDefaultSrc +
      '" ' +
      'alt="' +
      imgAlt +
      '"  ';

    if (activeSwapImage) {
      html +=
        ' data-img-flip-src="' +
        Utils.optimizeImage(images[1]["src"], rangeWidths[2] + "x") +
        '" ' +
        'data-img-flip-srcset="' +
        flipImageSrcSet +
        '" ';
    }
    html += "/></a>";

  }

  return html;
}


  function buildVendor(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_vendor") &&
      boostPFSThemeConfig.custom.show_vendor == true
    ) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildSavePrice(data, variantId) {
    var html = "";

    /* Start Boost 217733 - lb */
    var PricePerLB = Utils.getProductMetafield(
      data,
      "PricePerLB",
      "PricePerLB"
    );
    if (PricePerLB == null) {
      PricePerLB = 4;
    }
    var comparePriceLB =
      Math.floor((data.compare_at_price_min * 100) / PricePerLB) / 100;
    var priceMinLB = Math.floor((data.price_min * 100) / PricePerLB) / 100;
    var percentSaveLB = Math.ceil(
      ((data.compare_at_price_min - data.price_min) * 100) /
      data.compare_at_price_min
    );
    /* End Boost 217733 - lb */

    html += '<div class="collection-you-save">';
    if (data.percent_sale_min > 0) {
      var priceMetafield = Utils.getProductMetafield(
        data,
        "hide-add-to-cart",
        "hide-add-to-cart"
      );
      if (
        priceMetafield == "true" ||
        data.tags.indexOf("price_hidden") !== -1
      ) {
      } else {
        // if (data.title == 'Star Trac 4UB Upright Bike') {
        //   var savedPrice = data.compare_at_price_max - data.price_max;
        //   var percentSale = 16;
        // } else {
        //   var savedPrice = data.compare_at_price_min - data.price_min;
        //   var percentSale = data.percent_sale_min;
        // }
        var savedPrice =
          data.variants[0]["compare_at_price"] - data.variants[0]["price"];
        var percentSale = Math.ceil(
          Math.abs(
            (data.variants[0]["price"] * 100) /
            data.variants[0]["compare_at_price"] -
            100
          )
        );

        if (
          data.tags.includes("PriceSQFT")
        ) {
          /* Fix issue "You save price also divided by ACF field" */
          var foundVariantMeta = "";

          if (data.hasOwnProperty("metafields")) {
            foundVariantMeta = data.metafields.filter(function (e) {
              return (
                e.namespace == "price-per-sq-ft" &&
                e.key == "price-per-sq-ft" &&
                e.hasOwnProperty("id")
              );
            });
          }

          if (
            data.variants.length == 1 &&
            data.variants[0]["title"] == "Default title"
          ) {
            if (
              foundVariantMeta != "" &&
              typeof foundVariantMeta[0] !== "undefined"
            ) {
              savedPrice = savedPrice / foundVariantMeta[0]["value"];
            } else {
              savedPrice = savedPrice / 4;
            }
          } else if (
            data.variants.length > 1 ||
            (data.variants.length == 1 &&
              data.variants[0]["title"] != "Default title")
          ) {
            if (
              foundVariantMeta != "" &&
              typeof foundVariantMeta[0] !== "undefined"
            ) {
              if (typeof variantId !== "undefined") {
                var selectedVariant = foundVariantMeta.filter(function (e) {
                  return e.id == variantId;
                });
                var foundVariant = data.variants.filter(function (e) {
                  return e.id == selectedVariant[0]["id"];
                });

                if (typeof foundVariant[0] !== "undefined") {
                  if (
                    parseFloat(foundVariant[0]["compare_at_price"]) >
                    parseFloat(foundVariant[0]["price"])
                  ) {
                    savedPrice =
                      (foundVariant[0]["compare_at_price"] -
                        foundVariant[0]["price"]) /
                      selectedVariant[0]["value"];
                  } else {
                    savedPrice = 0;
                  }
                } else {
                  savedPrice = savedPrice / 4;
                }

                percentSale = Math.ceil(
                  ((parseFloat(foundVariant[0]["compare_at_price"]) -
                    parseFloat(foundVariant[0]["price"])) /
                    parseFloat(foundVariant[0]["compare_at_price"])) *
                  100
                );
              } else {
                var foundVariant = data.variants.filter(function (e) {
                  return e.id == foundVariantMeta[0]["id"];
                });

                if (typeof foundVariant[0] !== "undefined") {
                  if (
                    foundVariant[0]["compare_at_price"] >
                    foundVariant[0]["price"]
                  ) {
                    savedPrice =
                      (foundVariant[0]["compare_at_price"] -
                        foundVariant[0]["price"]) /
                      foundVariantMeta[0]["value"];
                  } else {
                    savedPrice = 0;
                  }
                } else {
                  savedPrice = savedPrice / 4;
                }
              }
            } else {
              if (
                Utils.getProductMetafield(
                  data,
                  "price-per-sq-ft",
                  "price-per-sq-ft"
                ) !== null
              ) {
                savedPrice =
                  savedPrice /
                  Utils.getProductMetafield(
                    data,
                    "price-per-sq-ft",
                    "price-per-sq-ft"
                  );
              } else {
                savedPrice = savedPrice;
              }
            }
          }
          // if (isFlooringCollection) savedPrice = savedPrice / 4;
          /* End fix */
          if (window.innerWidth <= 767) {
            // Mobile: Only show lowest price 
            
                const pricePerSQFTMap = {};
                    data.metafields.forEach(metafield => {
                      if (metafield.namespace === "price-per-sq-ft") {
                        pricePerSQFTMap[metafield.id] = parseFloat(metafield.value);
                      }
                    });
                    
                    const variants = data.variants.map(variant => {
                      const pricePerSQFT = pricePerSQFTMap[variant.id];
                      return {
                        ...variant,
                        compare_at_price_per_sqft: pricePerSQFT
                          ? variant.compare_at_price / pricePerSQFT
                          : variant.compare_at_price,
                        price_per_sqft: pricePerSQFT
                          ? variant.price / pricePerSQFT
                          : variant.price
                      };
                    });
                    
                    // Find the variant with the minimum price_per_sqft
                    const minPriceVariant = variants.reduce((minVariant, currentVariant) => {
                      return (currentVariant.price_per_sqft < minVariant.price_per_sqft)
                        ? currentVariant
                        : minVariant;
                    }, variants[0]);
                    
                    // const lowestPriceVariantId = minPriceVariant.id;
                    const priceMinSQFT = minPriceVariant.price_per_sqft;
                    const comparePriceSQFT = minPriceVariant.compare_at_price_per_sqft;
                    const percentSaveSQFT = Math.ceil((comparePriceSQFT - priceMinSQFT) * 100 / comparePriceSQFT);
                    
                    // foundVariant = lowestPriceVariantId;
                    savedPrice = Number(comparePriceSQFT) - Number(priceMinSQFT);
                    percentSale = percentSaveSQFT;
  
               
            }
        }
        // Start boost 224791
        if (variantId && !data.tags.includes("PriceSQFT")) {
          var selectedVariant = data.variants.find(
            (variant) => variant.id == variantId
          );
          var selectedVariantPrice = parseFloat(selectedVariant.price);
          var selectedVariantCompareAtPrice = parseFloat(
            selectedVariant.compare_at_price
          );
          if (
            selectedVariant &&
            selectedVariantCompareAtPrice > selectedVariantPrice
          ) {
            if (data.tags.includes("PriceLB")) {
              const pricePerLBMap = {};
              data.metafields.forEach(metafield => {
                if (metafield.namespace === 'PricePerLB') {
                  pricePerLBMap[metafield.id] = parseFloat(metafield.value);
                }
              });

              const variants = data.variants.map(variant => {
                const pricePerLB = pricePerLBMap[variant.id];
                return {
                  ...variant,
                  compare_at_price_per_lb: pricePerLB ? variant.compare_at_price / pricePerLB : variant.compare_at_price,
                  price_per_lb: pricePerLB ? variant.price / pricePerLB : variant.price
                };
              });

              // Find the variant with the minimum price_per_lb
              const minPriceVariant = variants.reduce((minVariant, currentVariant) => {
                return (currentVariant.price_per_lb < minVariant.price_per_lb) ? currentVariant : minVariant;
              }, variants[0]);

              // const lowestPriceVariantId = minPriceVariant.id;
              const priceMinLB = minPriceVariant.price_per_lb;
              const comparePriceLB = minPriceVariant.compare_at_price_per_lb;
              const percentSaveLB = Math.ceil((comparePriceLB - priceMinLB) * 100 / comparePriceLB);
              // foundVariant = lowestPriceVariantId;
              savedPrice = Number(comparePriceLB) - Number(priceMinLB);
              percentSale = percentSaveLB;
              // var comparePriceLB =
              //   Math.floor((selectedVariantCompareAtPrice * 100) / PricePerLB) /
              //   100;
              // var priceMinLB =
              //   Math.floor((selectedVariantPrice * 100) / PricePerLB) / 100;
              // var percentSaveLB = Math.ceil(
              //   ((selectedVariantCompareAtPrice - selectedVariantPrice) * 100) /
              //     selectedVariantCompareAtPrice
              // );
              // savedPrice = comparePriceLB - priceMinLB;
              // percentSale = percentSaveLB;
            } else {
              savedPrice = selectedVariantCompareAtPrice - selectedVariantPrice;
              percentSale = Math.ceil(
                Math.abs(
                  (selectedVariantPrice * 100) / selectedVariantCompareAtPrice -
                  100
                )
              );
              if (window.discountValuePercent && window.discountValuePercent > 0) {
                savedPrice = selectedVariantCompareAtPrice - (selectedVariantPrice * (100 - window.discountValuePercent) / 100);
                percentSale = Math.floor(
                  Math.abs(
                    (selectedVariantPrice * (100 - window.discountValuePercent)) / selectedVariantCompareAtPrice -
                    100
                  )
                );
              }
            }
          } else {
            savedPrice = 0
          }
        }
        // End boost 224791
        if (savedPrice > 0)
          html +=
            '<div class="product-single_you-save">Save <span class="product-single__you-save-amount">' +
            Utils.formatMoney(savedPrice) +
            " (" +
            percentSale +
            "%)</span></div>";
      }
    }
    html += "</div>";
    return html;
  }

  // function buildPrice(data, variantId) {
  //   var html = "";

  //   var priceMetafield = Utils.getProductMetafield(
  //     data,
  //     "hide-add-to-cart",
  //     "hide-add-to-cart"
  //   );

  //   var firstVariantPrice;
  //   var comparePriceMin;
  //   var priceMin;

  //   // Start Boost 161407
  //   var ACF = Utils.getProductMetafield(
  //     data,
  //     "price-per-sq-ft",
  //     "price-per-sq-ft"
  //   );
  //   // End Boost 161407

  //   /* Start Boost 217733 - lb */
  //   var PricePerLB = Utils.getProductMetafield(
  //     data,
  //     "PricePerLB",
  //     "PricePerLB"
  //   );
  //   if (PricePerLB == null) {
  //     PricePerLB = 4;
  //   }
  //   var comparePriceLB =
  //     Math.floor((data.compare_at_price_min * 100) / PricePerLB) / 100;
  //   var priceMinLB = Math.floor((data.price_min * 100) / PricePerLB) / 100;
  //   /* End Boost 217733 - lb */

  //   if (data.tags.includes("PriceSQFT")) {
  //     // Start Boost 161407

  //     // if (ACF) {
  //     //     firstVariantPrice = Utils.formatMoney(firstVariant.price / ACF) + ' <small>/sqft</small>';
  //     //     comparePriceMin = Utils.formatMoney(data.compare_at_price_min / ACF) + ' <small>/sqft</small>';
  //     //     priceMin = Utils.formatMoney(data.price_min / ACF) + ' <small>/sqft</small>';
  //     // } else {
  //     //     firstVariantPrice = Utils.formatMoney(firstVariant.price / 4) + ' <small>/sqft</small>';
  //     //     comparePriceMin = Utils.formatMoney(data.compare_at_price_min / 4) + ' <small>/sqft</small>';
  //     //     priceMin = Utils.formatMoney(data.price_min / 4) + ' <small>/sqft</small>';
  //     // }
  //     var foundVariantMeta = "";
  //     if (data.hasOwnProperty("metafields")) {
  //       foundVariantMeta = data.metafields.filter(function (e) {
  //         return (
  //           e.namespace == "price-per-sq-ft" &&
  //           e.key == "price-per-sq-ft" &&
  //           e.hasOwnProperty("id")
  //         );
  //       });
  //     }

  //     /* Henry-161407 */
  //     if (
  //       foundVariantMeta != "" &&
  //       typeof foundVariantMeta[0] !== "undefined"
  //     ) {
  //       if (typeof variantId !== "undefined") {
  //         var selectedVariantMeta = foundVariantMeta.filter(function (e) {
  //           return e.id == variantId;
  //         });

  //         var foundVariant = data.variants.filter(function (e) {
  //           return e.id == variantId;
  //         });
  //         if (
  //           typeof selectedVariantMeta[0] !== "undefined" &&
  //           typeof foundVariant[0] !== "undefined"
  //         ) {
  //           firstVariantPrice =
  //             Utils.formatMoney(
  //               foundVariant[0].price / selectedVariantMeta[0]["value"]
  //             ) + " <small>/sqft</small>";
  //           comparePriceMin =
  //             Utils.formatMoney(
  //               foundVariant[0].compare_at_price /
  //                 selectedVariantMeta[0]["value"]
  //             ) + " <small>/sqft</small>";
  //           priceMin =
  //             Utils.formatMoney(
  //               foundVariant[0].price / selectedVariantMeta[0]["value"]
  //             ) + " <small>/sqft</small>";
  //         } else {
  //           firstVariantPrice =
  //             Utils.formatMoney(
  //               firstVariant.price / foundVariantMeta[0]["value"]
  //             ) + " <small>/sqft</small>";
  //           comparePriceMin =
  //             Utils.formatMoney(
  //               data.compare_at_price_min / foundVariantMeta[0]["value"]
  //             ) + " <small>/sqft</small>";
  //           priceMin =
  //             Utils.formatMoney(data.price_min / foundVariantMeta[0]["value"]) +
  //             " <small>/sqft</small>";
  //         }
  //       } else {
  //         firstVariantPrice =
  //           Utils.formatMoney(
  //             firstVariant.price / foundVariantMeta[0]["value"]
  //           ) + " <small>/sqft</small>";
  //         comparePriceMin =
  //           Utils.formatMoney(
  //             data.compare_at_price_min / foundVariantMeta[0]["value"]
  //           ) + " <small>/sqft</small>";
  //         priceMin =
  //           Utils.formatMoney(data.price_min / foundVariantMeta[0]["value"]) +
  //           " <small>/sqft</small>";
  //       }
  //     } else if (ACF && foundVariantMeta == "") {
  //       firstVariantPrice =
  //         Utils.formatMoney(firstVariant.price / ACF) + " <small>/sqft</small>";
  //       comparePriceMin =
  //         Utils.formatMoney(data.compare_at_price_min / ACF) +
  //         " <small>/sqft</small>";
  //       priceMin =
  //         Utils.formatMoney(data.price_min / ACF) + " <small>/sqft</small>";
  //     } else {
  //       firstVariantPrice =
  //         Utils.formatMoney(firstVariant.price / 4) + " <small>/sqft</small>";
  //       comparePriceMin =
  //         Utils.formatMoney(data.compare_at_price_min / 4) +
  //         " <small>/sqft</small>";
  //       priceMin =
  //         Utils.formatMoney(data.price_min / 4) + " <small>/sqft</small>";
  //     }
  //     /* End-161407 */
  //   } else {
  //     firstVariantPrice = Utils.formatMoney(parseFloat(firstVariant.price));
  //     // if(data.title == 'Stairmaster 10G' || data.title == 'Star Trac 4UB Upright Bike') {
  //     //   comparePriceMin = Utils.formatMoney(data.compare_at_price_max);
  //     // }else {
  //     //   comparePriceMin = Utils.formatMoney(data.compare_at_price_min);
  //     // }
  //     if (
  //       data.title == "Stairmaster 10G" ||
  //       data.title == "Star Trac 4UB Upright Bike"
  //     ) {
  //       comparePriceMin = Utils.formatMoney(
  //         parseFloat(firstVariant.compare_at_price)
  //       );
  //     } else {
  //       comparePriceMin = Utils.formatMoney(data.compare_at_price_min);
  //     }
  //     priceMin = Utils.formatMoney(data.price_min);
  //     // End Boost 161407
  //     // Start boost 224019
  //     if (variantId) {
  //       var selectedVariant = data.variants.find(
  //         (variant) => variant.id == variantId
  //       );
  //       if (selectedVariant) {
  //         firstVariantPrice = Utils.formatMoney(
  //           parseFloat(selectedVariant.price)
  //         );
  //         comparePriceMin = Utils.formatMoney(
  //           parseFloat(selectedVariant.compare_at_price)
  //         );
  //       }
  //     }
  //     // End boost 224019
  //   }

  //   if (data.variants) {
  //     if (
  //       priceMetafield == "true" ||
  //       data.tags.indexOf("price_hidden") !== -1
  //     ) {
  //       //html += '<a href="/pages/store-locator" class="btn order_from_store_btn">Order from store</a>';
  //     } else if (data.tags.includes("PriceLB")) {
  //     /* Start Boost 217733 - lb */
  //       //html = '<p class="boost-pfs-filter-product-item-price">';
  //       if (onSale) {
  //         html +=
  //           '<span class="compare_price">' +
  //           Utils.formatMoney(comparePriceLB) +
  //           " /lb</span> ";
  //         html +=
  //           '<span class="price sale-price from_text hide_from_text">' +
  //           Utils.formatMoney(priceMinLB) +
  //           " /lb</span>";
  //       } else {
  //         if (priceVaries) {
  //           //html += '<span class="price from_text hide_from_text">From </span>';
  //         }
  //         html +=
  //           '<span class="price">' +
  //           Utils.formatMoney(priceMinLB) +
  //           " /lb</span>";
  //       }
  //       //html += '</p>';
  //     } else {
  //     /* End Boost 217733 - lb */
  //       //html = '<p class="boost-pfs-filter-product-item-price">';
  //       if (onSale && firstVariant.price < firstVariant.compare_at_price) {
  //         html += '<span class="compare_price">' + comparePriceMin + "</span> ";
  //         html +=
  //           '<span class="price sale-price from_text hide_from_text">' +
  //           firstVariantPrice +
  //           "</span>";
  //       } else {
  //         if (priceVaries) {
  //           //html += '<span class="price from_text hide_from_text">From </span>';
  //         }
  //         html += '<span class="price">' + firstVariantPrice + "</span>";
  //       }
  //       //html += '</p>';
  //     }
  //   } else {
  //     if (
  //       priceMetafield == "true" ||
  //       data.tags.indexOf("price_hidden") !== -1
  //     ) {
  //       //html += '<a href="/pages/store-locator" class="btn order_from_store_btn">Order from store</a>';
  //     } else if (data.tags.includes("PriceLB")) {
  //       const pricePerLBMap = {};
  //           data.metafields.forEach(metafield => {
  //               if (metafield.namespace === 'PricePerLB') {
  //                   pricePerLBMap[metafield.id] = parseFloat(metafield.value);
  //               }
  //           });

  //           const variants = data.variants.map(variant => {
  //               const pricePerLB = pricePerLBMap[variant.id];
  //               return {
  //                   ...variant,
  //                   compare_at_price_per_lb: pricePerLB ? variant.compare_at_price / pricePerLB : variant.compare_at_price,
  //                   price_per_lb: pricePerLB ? variant.price / pricePerLB : variant.price
  //               };
  //           });

  //         // Find the variant with the minimum price_per_lb
  //         const minPriceVariant = variants.reduce((minVariant, currentVariant) => {
  //             return (currentVariant.price_per_lb < minVariant.price_per_lb) ? currentVariant : minVariant;
  //         }, variants[0]);

  //         const priceMinLB = minPriceVariant.price_per_lb;
  //         const comparePriceLB = minPriceVariant.compare_at_price_per_lb;
  //           console.log('comparePriceLB----'+ comparePriceLB)
  //         // Generate HTML

  //        html += onSale
  //                 ? `<span class="compare_price">${Utils.formatMoney(comparePriceLB)} /lb</span> <span class="price sale-price from_text hide_from_text">${Utils.formatMoney(priceMinLB)} /lb</span>`
  //                 : `<span class="price">${Utils.formatMoney(priceMinLB)} /lb</span>`;
  //     /* Start Boost 217733 - lb */
  //       //html = '<p class="boost-pfs-filter-product-item-price">';
  //       // if (onSale) {
  //       //   html +=
  //       //     '<span class="compare_price">' +
  //       //     Utils.formatMoney(comparePriceLB) +
  //       //     " /lb</span> ";
  //       //   html +=
  //       //     '<span class="price sale-price from_text hide_from_text">' +
  //       //     Utils.formatMoney(priceMinLB) +
  //       //     " /lb</span>";
  //       // } else {
  //       //   if (priceVaries) {
  //       //     //html += '<span class="price from_text hide_from_text">From </span>';
  //       //   }
  //       //   html +=
  //       //     '<span class="price">' +
  //       //     Utils.formatMoney(priceMinLB) +
  //       //     " /lb</span>";
  //       // }
  //       //html += '</p>';
  //     } else {
  //     /* End Boost 217733 - lb */
  //       //html = '<p class="boost-pfs-filter-product-item-price">';
  //       if (onSale) {
  //         html += '<span class="compare_price">' + comparePriceMin + "</span> ";
  //         html +=
  //           '<span class="price sale-price from_text hide_from_text">' +
  //           priceMin +
  //           "</span>";
  //       } else {
  //         if (priceVaries) {
  //           //html += '<span class="price from_text hide_from_text">From </span>';
  //         }
  //         html += '<span class="price">' + priceMin + "</span>";
  //       }
  //       //html += '</p>';
  //     }
  //   }

  //   return html;
  // }
  function buildPrice(data, variantId) {
    // console.log('buildPricedata----------', data)
    var html = "";
    var priceMetafield = Utils.getProductMetafield(
      data,
      "hide-add-to-cart",
      "hide-add-to-cart"
    );

    var firstVariantPrice;
    var comparePriceMin;
    var priceMin;

    // Start Boost 161407
    var ACF = Utils.getProductMetafield(
      data,
      "price-per-sq-ft",
      "price-per-sq-ft"
    );
    // End Boost 161407

    /* Start Boost 217733 - lb */
    var PricePerLB = Utils.getProductMetafield(
      data,
      "PricePerLB",
      "PricePerLB"
    );
    if (PricePerLB == null) {
      PricePerLB = 4;
    }
    var comparePriceLB =
      Math.floor((data.compare_at_price_min * 100) / PricePerLB) / 100;
    var priceMinLB = Math.floor((data.price_min * 100) / PricePerLB) / 100;
    // console.log('priceminlb---' + priceMinLB)
    /* End Boost 217733 - lb */

    /* Boost - 228080 */
    if (data.tags.includes("PriceSQFT")) {
      var foundVariantMeta = "";
      if (data.hasOwnProperty("metafields")) {
        foundVariantMeta = data.metafields.filter(function (e) {
          return (
            e.namespace == "price-per-sq-ft" &&
            e.key == "price-per-sq-ft" &&
            e.hasOwnProperty("id")
          );
        });
      }

      /* Henry-161407 */
      if (
        foundVariantMeta != "" &&
        typeof foundVariantMeta[0] !== "undefined"
      ) {
        if (typeof variantId !== "undefined") {
          var selectedVariantMeta = foundVariantMeta.filter(function (e) {
            return e.id == variantId;
          });

          // console.log(selectedVariantMeta)
          var foundVariant = data.variants.filter(function (e) {
            return e.id == variantId;
          });
          if (
            typeof selectedVariantMeta[0] !== "undefined" &&
            typeof foundVariant[0] !== "undefined"
          ) {
            firstVariantPrice =
              Utils.formatMoney(
                foundVariant[0].price / selectedVariantMeta[0]["value"]
              ) + " <small>/sqft</small>";
            comparePriceMin =
              Utils.formatMoney(
                foundVariant[0].compare_at_price /
                selectedVariantMeta[0]["value"]
              ) + " <small>/sqft</small>";
            priceMin =
              Utils.formatMoney(
                foundVariant[0].price / selectedVariantMeta[0]["value"]
              ) + " <small>/sqft</small>";
          } else {
            firstVariantPrice =
              Utils.formatMoney(
                firstVariant.price / foundVariantMeta[0]["value"]
              ) + " <small>/sqft</small>";
            comparePriceMin =
              Utils.formatMoney(
                data.compare_at_price_min / foundVariantMeta[0]["value"]
              ) + " <small>/sqft</small>";
            priceMin =
              Utils.formatMoney(data.price_min / foundVariantMeta[0]["value"]) +
              " <small>/sqft</small>";
          }
        } else {
          firstVariantPrice =
            Utils.formatMoney(
              firstVariant.price / foundVariantMeta[0]["value"]
            ) + " <small>/sqft</small>";
          comparePriceMin =
            Utils.formatMoney(
              data.compare_at_price_min / foundVariantMeta[0]["value"]
            ) + " <small>/sqft</small>";
          priceMin =
            Utils.formatMoney(data.price_min / foundVariantMeta[0]["value"]) +
            " <small>/sqft</small>";
        }
      } else if (ACF && foundVariantMeta == "") {
        firstVariantPrice =
          Utils.formatMoney(firstVariant.price / ACF) + " <small>/sqft</small>";
        comparePriceMin =
          Utils.formatMoney(data.compare_at_price_min / ACF) +
          " <small>/sqft</small>";
        priceMin =
          Utils.formatMoney(data.price_min / ACF) + " <small>/sqft</small>";
      } else {
        firstVariantPrice =
          Utils.formatMoney(firstVariant.price / 4) + " <small>/sqft</small>";
        comparePriceMin =
          Utils.formatMoney(data.compare_at_price_min / 4) +
          " <small>/sqft</small>";
        priceMin =
          Utils.formatMoney(data.price_min / 4) + " <small>/sqft</small>";
      }

      if (onSale) {
        if (window.innerWidth <= 767) {
              // console.log('7896')
              // Mobile: Only show lowest price 
              const pricePerSQFTMap = {};
      
                data.metafields.forEach(metafield => {
                  if (metafield.namespace === 'price-per-sq-ft') {
                    pricePerSQFTMap[metafield.id] = parseFloat(metafield.value);
                  }
                });
                                
                const variants = data.variants.map(variant => {
                  const pricePerSQFT = pricePerSQFTMap[variant.id];
                  return {
                    ...variant,
                    compare_at_price_per_sqft: pricePerSQFT
                      ? variant.compare_at_price / pricePerSQFT
                      : variant.compare_at_price,
                    price_per_sqft: pricePerSQFT
                      ? variant.price / pricePerSQFT
                      : variant.price
                  };
                });
                
                // Find the variant with the minimum price_per_sqft
                const minPriceVariant = variants.reduce((minVariant, currentVariant) => {
                  return (currentVariant.price_per_sqft < minVariant.price_per_sqft)
                    ? currentVariant
                    : minVariant;
                }, variants[0]);
                
                const priceMinSQFT = minPriceVariant.price_per_sqft;
                const comparePriceSQFT = minPriceVariant.compare_at_price_per_sqft;
                
                // Render HTML
                html += onSale
                  ? `<span class="compare_price 1">${Utils.formatMoney(comparePriceSQFT)} <small>/sqft</small></span> 
                    <span class="price sale-price from_text hide_from_text">${Utils.formatMoney(priceMinSQFT)} <small>/sqft</small></span>`
                  : `<span class="price">${Utils.formatMoney(priceMinSQFT)} <small>/sqft</small></span>`;
      
            } else {
              // Desktop: Show full sale pricing
              if (comparePriceMin.indexOf('0.00') === -1) {
                html += '<span class="compare_price test123">' + comparePriceMin + "</span> ";
              }
              html += '<span class="price sale-price from_text hide_from_text">' + priceMin + "</span>";
            }
      }
    else {
        html += '<span class="price">' + priceMin + "</span>";
      }
      return html;

      /* End-161407 */
    } else {
      firstVariantPrice = Utils.formatMoney(parseFloat(firstVariant.price));
      if (
        data.title == "Stairmaster 10G" ||
        data.title == "Star Trac 4UB Upright Bike"
      ) {
        comparePriceMin = Utils.formatMoney(
          parseFloat(firstVariant.compare_at_price)
        );
      } else {
        comparePriceMin = Utils.formatMoney(data.compare_at_price_min);
      }
      priceMin = Utils.formatMoney(data.price_min);
      // End Boost 161407
      // Start boost 224019
      if (variantId) {
        var selectedVariant = data.variants.find(
          (variant) => variant.id == variantId
        );
        if (selectedVariant) {
          firstVariantPrice = Utils.formatMoney(
            parseFloat(selectedVariant.price)
          );
          comparePriceMin = Utils.formatMoney(
            parseFloat(selectedVariant.compare_at_price)
          );
        }
      }
      // End boost 224019
    }

    if (data.variants) {
      /* Start Boost 217733 - lb */
      if (data.tags.includes("PriceLB")) {
        const pricePerLBMap = {};
        data.metafields.forEach(metafield => {
          if (metafield.namespace === 'PricePerLB') {
            pricePerLBMap[metafield.id] = parseFloat(metafield.value);
          }
        });

        const variants = data.variants.map(variant => {
          const pricePerLB = pricePerLBMap[variant.id];
          return {
            ...variant,
            compare_at_price_per_lb: pricePerLB ? variant.compare_at_price / pricePerLB : variant.compare_at_price,
            price_per_lb: pricePerLB ? variant.price / pricePerLB : variant.price
          };
        });

        // Find the variant with the minimum price_per_lb
        const minPriceVariant = variants.reduce((minVariant, currentVariant) => {
          return (currentVariant.price_per_lb < minVariant.price_per_lb) ? currentVariant : minVariant;
        }, variants[0]);

        const priceMinLB = minPriceVariant.price_per_lb;
        const comparePriceLB = minPriceVariant.compare_at_price_per_lb;
        // console.log('comparePriceLB----' + comparePriceLB)
        // Generate HTML

        html += onSale
          ? `<span class="compare_price 1">${Utils.formatMoney(comparePriceLB)} /lb</span> <span class="price sale-price from_text hide_from_text">${Utils.formatMoney(priceMinLB)} /lb</span>`
          : `<span class="price">${Utils.formatMoney(priceMinLB)} /lb</span>`;
        // if (onSale) {
        //   html +=
        //     '<span class="compare_price">' +
        //     Utils.formatMoney(comparePriceLB) +
        //     " /lb</span> ";
        //   html +=
        //     '<span class="price sale-price from_text hide_from_text">' +
        //     Utils.formatMoney(priceMinLB) +
        //     " /lb</span>";
        // } else {
        //   html +=
        //     '<span class="price">' +
        //     Utils.formatMoney(priceMinLB) +
        //     " /lb</span>";
        // }
      } else {
        /* End Boost 217733 - lb */
        if (typeof variantId !== "undefined") {
          var foundVariant = data.variants.filter(function (e) {
            return e.id == variantId;
          });
          if (typeof foundVariant[0] !== "undefined") {
            if (
              onSale &&
              parseFloat(foundVariant[0].price) <
              parseFloat(foundVariant[0].compare_at_price)
            ) {
              if (window.discountValuePercent && window.discountValuePercent > 0) {
                html += '<a href="{{itemUrl}}">';
              }
              html +=
                '<span class="compare_price 2';
              if (window.discountValuePercent && window.discountValuePercent > 0) {
                html += ' gslinethrough" style="text-decoration: line-through;">';
              } else {
                html +=
                  '">';
              }
              html +=
                comparePriceMin;
              html +=
                "</span> ";
              if (window.discountValuePercent && window.discountValuePercent > 0) {
                html +=
                  '<span class="price sale-price from_text hide_from_text gslinethrough" style="text-decoration: line-through;">' +
                  Utils.formatMoney(parseFloat(foundVariant[0].price)) +
                  "</span>";
              } else {
                html +=
                  '<span class="price sale-price from_text hide_from_text">' +
                  Utils.formatMoney(parseFloat(foundVariant[0].price)) +
                  "</span>";
              }
              if (window.discountValuePercent && window.discountValuePercent > 0) {
                html += `<div style="font-size: 18px" class="discountedprice secondpricegs skiptranslate notranslate currency-converter-wrapper-amount-box">
                ${Utils.formatMoney(parseFloat(foundVariant[0].price * (100 - window.discountValuePercent) / 100))}
                ${discountcodemarkT ? discountcodemarkT : ''} </div>`;
                html += '</a>'
              }
            }
            else if(data.tags.indexOf("price_hidden") !== -1){
              html += '';
             }
            else {
              if (window.discountValuePercent && window.discountValuePercent > 0) {
                html += '<a href="{{itemUrl}}">';
                html +=
                  '<span class="price gslinethrough" style="text-decoration: line-through;">' +
                  Utils.formatMoney(parseFloat(foundVariant[0].price)) +
                  "</span>";
                html += `<div style="font-size: 18px" class="discountedprice secondpricegs skiptranslate notranslate currency-converter-wrapper-amount-box">
                ${Utils.formatMoney(parseFloat(foundVariant[0].price * (100 - window.discountValuePercent) / 100))}
                ${discountcodemarkT ? discountcodemarkT : ''} </div>`;
                html += '</a>'
              } else {
                html +=
                  '<span class="price">' +
                  Utils.formatMoney(parseFloat(foundVariant[0].price)) +
                  "</span>";
              }
            }
          } else {
            if (
              onSale &&
              parseFloat(firstVariant.price) <
              parseFloat(firstVariant.compare_at_price)
            ) {
              html +=
                '<span class="compare_price 3">' + comparePriceMin + "</span> ";
              html +=
                '<span class="price sale-price from_text hide_from_text">' +
                firstVariantPrice +
                "</span>";
            } else {
              html += '<span class="price">' + firstVariantPrice + "</span>";
            }
          }
        } else {
          if (
            onSale &&
            parseFloat(firstVariant.price) <
            parseFloat(firstVariant.compare_at_price)
          ) {
            html +=
              '<span class="compare_price">' + comparePriceMin + "</span> ";
            html +=
              '<span class="price sale-price from_text hide_from_text">' +
              firstVariantPrice +
              "</span>";
          } else {
            html += '<span class="price">' + firstVariantPrice + "</span>";
          }
        }
      }
    } else {
      if (data.tags.includes("PriceLB")) {
        const pricePerLBMap = {};
        data.metafields.forEach(metafield => {
          if (metafield.namespace === 'PricePerLB') {
            pricePerLBMap[metafield.id] = parseFloat(metafield.value);
          }
        });

        const variants = data.variants.map(variant => {
          const pricePerLB = pricePerLBMap[variant.id];
          return {
            ...variant,
            compare_at_price_per_lb: pricePerLB ? variant.compare_at_price / pricePerLB : variant.compare_at_price,
            price_per_lb: pricePerLB ? variant.price / pricePerLB : variant.price
          };
        });

        // Find the variant with the minimum price_per_lb
        const minPriceVariant = variants.reduce((minVariant, currentVariant) => {
          return (currentVariant.price_per_lb < minVariant.price_per_lb) ? currentVariant : minVariant;
        }, variants[0]);

        const priceMinLB = minPriceVariant.price_per_lb;
        const comparePriceLB = minPriceVariant.compare_at_price_per_lb;
        // console.log('comparePriceLB----' + comparePriceLB)
        // Generate HTML

        html += onSale
          ? `<span class="compare_price 4">${Utils.formatMoney(comparePriceLB)} /lb</span> <span class="price sale-price from_text hide_from_text">${Utils.formatMoney(priceMinLB)} /lb</span>`
          : `<span class="price">${Utils.formatMoney(priceMinLB)} /lb</span>`;
        // if (onSale) {
        //   html +=
        //     '<span class="compare_price">' +
        //     Utils.formatMoney(comparePriceLB) +
        //     " /lb</span> ";
        //   html +=
        //     '<span class="price sale-price from_text hide_from_text">' +
        //     Utils.formatMoney(priceMinLB) +
        //     " /lb</span>";
        // } else {
        //   if (priceVaries) {
        //     //html += '<span class="price from_text hide_from_text">From </span>';
        //   }
        //   html +=
        //     '<span class="price">' +
        //     Utils.formatMoney(priceMinLB) +
        //     " /lb</span>";
        // }
      } else {
        /* End Boost 217733 - lb */
        if (onSale) {
          html += '<span class="compare_price">' + comparePriceMin + "</span> ";
          html +=
            '<span class="price sale-price from_text hide_from_text">' +
            priceMin +
            "</span>";
        } else {
          html += '<span class="price">' + priceMin + "</span>";
        }
      }
    }
    return html;
  }
  function buildLabels(data) {
    // Build Sold out label
    var soldOutLabel = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("sold_out_enable") &&
      boostPFSThemeConfig.custom.sold_out_enable &&
      soldOut
    ) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
        /{{style}}/g,
        ""
      );
    }
    // Build Sale label
    var saleLabel = "";
    var salePercent = "";
    if (boostPFSThemeConfig.custom.sale_label_enable && onSale && !soldOut) {
      if (boostPFSThemeConfig.custom.sale_label_display == "sale_percent") {
        salePercent = Math.round(
          ((data.compare_at_price_min - data.price_min) * 100) /
          data.compare_at_price_max
        );
      }
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, "");
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(
        /percent/g,
        "-" + salePercent + "%"
      );
    }
    // Build Labels
    return soldOutLabel + saleLabel;
  }

  // BUILD LABEL PRODUCT WITH TAGS
  function buildTagLabels(data, showall) {
    if (boostPFSThemeConfig.custom.tag_label_enable) {
      if (showall) {
        var tagLabel = "";
        if (data.tags) {
          for (var i = 0; i < data.tags.length; i++) {
            var tag = data.tags[i];
            if (tag.indexOf("pfs:label") !== -1) {
              var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(
                /{{labelTag}}/g,
                tag.split("pfs:label-")[1]
              );
              tagLabel += preTagLabel;
            }
          }
        }
      } else {
        var tagLabel = "";
        if (data.tags) {
          for (var i = data.tags.length - 1; i >= 0; i--) {
            tag = data.tags[i];
            if (tag.indexOf("pfs:label") !== -1) {
              var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(
                /{{labelTag}}/g,
                tag.split("pfs:label-")[1]
              );
              tagLabel += preTagLabel;
              break;
            }
          }
        }
      }
      return tagLabel;
    } else {
      return "";
    }
  }

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  // Build Color Swatches
  function buildProductOptionSwatches(data) {
    var swatchesProductOptionHtml = "";
    //if (boostPFSThemeConfig.custom.swatch_enable) {
    var swatchApplyFor = ["pro_img"];
    for (var i = 0; i < swatchApplyFor.length; i++) {
      var optionNames = ["color"];
      var swatchShape = "";
      var swatchType = swatchApplyFor[i];
      for (var j = 0; j < optionNames.length; j++) {
        var optionName = optionNames[j].trim();
        var filterSwatchTitle = optionName,
          swatchArr = [],
          countSwatch = 0,
          swatchValues = [],
          swatchLimit = 4,
          sImageIndex = -1,
          swatchVariant = {};

        var dataImgSize = "360",
          bgSize = "50x",
          dataImgSrc = Utils.getFeaturedImage(
            data.images_info,
            dataImgSize + "x"
          ),
          swatchName = "#ffffff",
          bgImageSrc = "",
          viewMoreLabel = "More " + filterSwatchTitle;
        swatchesProductOptionHtml +=
          '<div class="main-boost-pfs-filter-variant-swatch">';
        if (
          typeof data.options_with_values != "undefined" &&
          data.options_with_values.length > 0
        ) {
          swatchArr = data.options_with_values.filter(function (option) {
            return option.name == optionName;
          });
          if (swatchArr.length > 0) {
            countSwatch = swatchArr[0].values.length;

            if (swatchLimit > countSwatch) {
              swatchLimit = countSwatch;
            }
            swatchValues = swatchArr[0].values;

            swatchesProductOptionHtml +=
              '<ul class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-option' +
              optionName +
              " boost-pfs-filter-item-swatch-shape-" +
              swatchShape +
              " boost-pfs-filter-item-swatch-type-" +
              swatchType +
              '">';

            for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
              swatchName = swatchValues[sIndex].title;
              swatchVariant = data["variants"].find(function (e) {
                return e.option_color == swatchName;
              });
              if (typeof swatchVariant == "undefined") {
                swatchVariant = data["variants"].find(function (e) {
                  return e.title == swatchName;
                });
              }
              sImageIndex = swatchValues[sIndex].image || "";
              if (sImageIndex != "") {
                dataImgSrc =
                  Utils.optimizeImage(
                    data.images[sImageIndex],
                    dataImgSize + "x"
                  ) +
                  " " +
                  dataImgSize +
                  "w";
              }

              if (swatchType) {
                switch (swatchType) {
                  case "img":
                    bgImageSrc = boostPFSAppConfig.general.file_url.replace(
                      /\?/,
                      Utils.slugify(filterSwatchTitle).replace(/\-/g, "_") +
                      "-" +
                      Utils.slugify(swatchName) +
                      ".png?v="
                    );
                    break;
                  case "pro_img":
                    bgImageSrc = getSwatchImage(data, swatchName);
                    if (sImageIndex != "") {
                      bgImageSrc = Utils.optimizeImage(
                        data.images[sImageIndex],
                        bgSize
                      );
                    }
                    break;
                  default:
                    bgImageSrc = "";
                }
              }
              if (sIndex == 0) {
                swatchesProductOptionHtml += '<li class="active">';
              } else {
                swatchesProductOptionHtml += "<li>";
              }

              if (swatchType == "text") {
                swatchesProductOptionHtml +=
                  '<a aria-label="' +
                  optionName +
                  ": " +
                  swatchName +
                  '" title="' +
                  swatchName +
                  '" href="' +
                  Utils.buildProductItemUrl(data) +
                  "?variant=" +
                  swatchVariant.id +
                  '">' +
                  swatchName +
                  "</a>";
              } else {
                if (boostPFSThemeConfig.custom.show_swatch_tooltip) {
                  swatchesProductOptionHtml +=
                    '<div class="boost-pfs-product-item-tooltip">' +
                    swatchName +
                    "</div>";
                }
                swatchesProductOptionHtml +=
                  '<span tabindex="0" aria-label="' +
                  optionName +
                  ": " +
                  swatchName +
                  '" ' +
                  'style="background-color: ' +
                  optionName +
                  "; ";
                if (bgImageSrc != "") {
                  swatchesProductOptionHtml +=
                    "background-image: url(" + bgImageSrc + ');" ';
                } else {
                  swatchesProductOptionHtml += '" ';
                }
                if (dataImgSrc != "") {
                  swatchesProductOptionHtml += 'data-img="' + dataImgSrc + '" ';
                }
                /* start-boost-custom */
                /* #boost-118852: show variant price when clicking on the swatch */
                /* Henry-161407 */
                swatchesProductOptionHtml +=
                  'data-product_id="' + data.id + '" ';
                /* End-161407 */
                if (swatchVariant) {
                  swatchesProductOptionHtml +=
                    'data-variant_id="' + swatchVariant.id + '" ';
                  swatchesProductOptionHtml +=
                    'data-price="' + swatchVariant.price + '" ';
                  swatchesProductOptionHtml +=
                    'data-compare_price="' +
                    (swatchVariant.compare_at_price || 0) +
                    '" ';
                }
                /* end-boost-custom */
                swatchesProductOptionHtml += "></span>";
              }
              swatchesProductOptionHtml += "</li>";
            }

            if (countSwatch > swatchLimit) {
              swatchesProductOptionHtml +=
                '<li class="boost-pfs-filter-item-swatch-more">';
              swatchesProductOptionHtml +=
                '<a href="{{itemUrl}}" aria-label="' +
                viewMoreLabel +
                '" title="' +
                viewMoreLabel +
                '">+' +
                (countSwatch - swatchLimit) +
                "</a>";
              swatchesProductOptionHtml += "</li>";
            }

            swatchesProductOptionHtml += "</ul>";
          }
        }
        swatchesProductOptionHtml += "</div>";
      }
    }
    //}
    return swatchesProductOptionHtml;
  }

  function getSwatchImage(data, color) {
    var images_info = data.images_info;
    for (var i = 0; i < images_info.length; i++) {
      if (images_info[i].src.indexOf(color) !== -1) {
        return Utils.optimizeImage(images_info[i].src, "50x");
      }
    }
    return Utils.optimizeImage(images_info[0].src, "50x");
  }

  // Build Color Swatches
  /* start-boost-custom */
  /* #boost-118852: show variant price when clicking on the swatch */
  function eventColorSwatches(event, data) {
    jQ(".boost-pfs-filter-item-swatch li span").each(function () {
      var img = jQ(this)
        .closest(".product-collection")
        .find(".boost-pfs-filter-product-item-main-image");
      var $price = jQ(this)
        .closest(".product-collection")
        .find(".product-collection__list-v2-price");
      var $product = jQ(this).closest(".product-collection");
      if (event == "hover") {
        jQ(this).hover(function () {
          var newImage = jQ(this).attr("data-img");
          img.attr("srcset", newImage);

          var variantPrice = Number(jQ(this).attr("data-price"));
          var variantComparePrice = Number(jQ(this).attr("data-compare_price"));
          onSale = variantComparePrice > variantPrice;
          priceVaries = false;

          // var priceHtml = buildPrice({
          //     compare_at_price_min: variantComparePrice,
          //     price_min: variantPrice,
          //     tags: []
          // });
          /* Henry-161407 */
          var priceHtml = buildPrice(data);
          /* End-161407 */

          $price.html(priceHtml);

          var variantId = jQ(this).data("variant_id");
          $product.find("select option").attr("value", variantId);
        });
      }
      if (event == "click") {
        jQ(this).click(function () {
          var newImage = jQ(this).attr("data-img");
          img.attr("srcset", newImage);
          jQ(this).closest("ul").find("li").removeClass("active");
          jQ(this).parent().addClass("active");

          var variantPrice = Number(jQ(this).attr("data-price"));
          var variantComparePrice = Number(jQ(this).attr("data-compare_price"));
          // console.log(variantComparePrice);
          onSale = variantComparePrice > variantPrice;
          priceVaries = false;

          // var priceHtml = buildPrice({
          //     compare_at_price_min: variantComparePrice,
          //     price_min: variantPrice,
          //     tags: []
          // });
          /* Henry-161407 */
          var prodId = Number(jQ(this).attr("data-product_id"));
          var variantId = jQ(this).attr("data-variant_id");
          var foundProduct = data.products.filter(function (e) {
            return e.id == prodId;
          });
          var priceHtml = buildPrice(foundProduct[0], variantId);
          /* Fix issue "You save price also divided by ACF field" */
          var savedPriceHtml = buildSavePrice(foundProduct[0], variantId);
          /* End - Fix issue "You save price also divided by ACF field" */
          /* End-161407 */
          // Start boost 224019
          $price.html(priceHtml);
          // End boost 224019
          /* Fix issue "You save price also divided by ACF field" */
          jQ(this)
            .closest(".product-collection")
            .find(".collection-you-save")
            .remove();
          // Start boost 224791
          $price.after(savedPriceHtml);
          // End boost 224791
          /* End - Fix issue "You save price also divided by ACF field" */
          $product.find("select option").attr("value", variantId);
        });
      }
      jQ(this).focus(function () {
        if (jQ("body").hasClass("boost-pfs-ada")) {
          var newImage = jQ(this).data("img");
          img.attr("srcset", newImage);
        }
      });
    });
  }
  /* end-boost-custom */

  function buildReview(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_product_review") &&
      boostPFSThemeConfig.custom.show_product_review == true
    ) {
      html =
        '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
    }
    return html;
  }

  function buildActiveSwapClass(data) {
    if (
      !Utils.isMobile() &&
      images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
      boostPFSThemeConfig.custom.active_image_swap == true
    ) {
      return "has-bc-swap-image";
    }
    return "";
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
    var totalPage = Math.ceil(
      totalProduct / Utils.stripHtml(Globals.queryParams.limit)
    );
    if (!currentPage || isNaN(currentPage)) {
      currentPage = 1;
    }
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1
        ? boostPFSTemplate.previousActiveHtml
        : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage
        ? boostPFSTemplate.nextActiveHtml
        : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          sortingItemsHtml +=
            '<option value="' + k + '">' + sortingArr[k] + "</option>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  // For Toolbar - Build Display type
  ProductDisplayType.prototype.compileTemplate = function () {
    var itemHtml = "<span>View as</span>";
    if (boostPFSThemeConfig.custom.product_item_type == "grid") {
      if (
        boostPFSThemeConfig.custom.view_as_type ==
        "view_as_type_list_grid_multi_col" &&
        !Utils.isMobile()
      ) {
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "grid", "list") +
          '" title="' +
          buildDisplayTitle("list") +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">';
        itemHtml += `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-187" viewBox="0 0 24 24">
    		<path d="M20.574,2.567c-0.117-0.117-0.268-0.176-0.449-0.176H3.25c-0.183,0-0.332,0.059-0.449,0.176S2.625,2.835,2.625,3.017v16.875
                c0,0.183,0.059,0.332,0.176,0.449s0.267,0.176,0.449,0.176h16.875c0.182,0,0.332-0.059,0.449-0.176s0.176-0.267,0.176-0.449V3.017
                C20.75,2.835,20.691,2.685,20.574,2.567z M8.25,19.267H3.875v-4.375H8.25V19.267z M8.25,13.642H3.875V9.267H8.25V13.642z
                 M8.25,8.017H3.875V3.642H8.25V8.017z M19.5,19.267h-1.578h-2.797h-1.25h-2.531H9.5v-4.375h1.844h2.531h1.25h2.797H19.5V19.267z
                 M19.5,13.642h-1.938h-2.437h-1.25h-2.063H9.5V9.267h2.312h2.063h1.25h2.437H19.5V13.642z M19.5,8.017h-2.328h-2.047h-1.25h-1.422
                H9.5V3.642h2.953h1.422h1.25h2.047H19.5V8.017z"></path>
            </svg>`;
        itemHtml += "</span></a>";
        //itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 2) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "list", "grid") +
          '" title="' +
          buildDisplayTitle("grid", 3) +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3 active" data-view="grid-3"><span class="icon-fallback-text">';
        itemHtml += `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-186" viewBox="0 0 24 24">
            <g>
                <path d="M2.828,2.567C2.945,2.45,3.095,2.392,3.277,2.392h16.875c0.183,0,0.332,0.059,0.449,0.176s0.176,0.268,0.176,0.449v16.875
                    c0,0.183-0.059,0.332-0.176,0.449s-0.267,0.176-0.449,0.176H3.277c-0.183,0-0.332-0.059-0.449-0.176s-0.176-0.267-0.176-0.449
                    V3.017C2.652,2.835,2.711,2.685,2.828,2.567z M3.902,3.642v4.375h4.375V3.642H3.902z M8.277,9.267H3.902v4.375h4.375V9.267z
                     M3.902,19.267h4.375v-4.375H3.902V19.267z M13.902,8.017V3.642H9.527v4.375H13.902z M9.527,9.267v4.375h4.375V9.267H9.527z
                     M9.527,14.892v4.375h4.375v-4.375H9.527z M19.527,3.642h-4.375v4.375h4.375V3.642z M19.527,9.267h-4.375v4.375h4.375V9.267z
                     M19.527,19.267v-4.375h-4.375v4.375H19.527z"></path>
            </g>
            </svg>`;
        itemHtml += "</span></a>";
        //itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 4) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
        //itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 5) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
        //itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 6) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
      } else {
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "list", "grid") +
          '" title="' +
          buildDisplayTitle("grid") +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "grid", "list") +
          '" title="' +
          buildDisplayTitle("list") +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">';
        itemHtml += "</span></a>";
      }
    } else {
      if (
        boostPFSThemeConfig.custom.view_as_type ==
        "view_as_type_list_grid_multi_col" &&
        !Utils.isMobile()
      ) {
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "grid", "list") +
          '" title="' +
          buildDisplayTitle("list") +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">';
        itemHtml += `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-187" viewBox="0 0 24 24">
    <path d="M20.574,2.567c-0.117-0.117-0.268-0.176-0.449-0.176H3.25c-0.183,0-0.332,0.059-0.449,0.176S2.625,2.835,2.625,3.017v16.875
    	c0,0.183,0.059,0.332,0.176,0.449s0.267,0.176,0.449,0.176h16.875c0.182,0,0.332-0.059,0.449-0.176s0.176-0.267,0.176-0.449V3.017
    	C20.75,2.835,20.691,2.685,20.574,2.567z M8.25,19.267H3.875v-4.375H8.25V19.267z M8.25,13.642H3.875V9.267H8.25V13.642z
    	 M8.25,8.017H3.875V3.642H8.25V8.017z M19.5,19.267h-1.578h-2.797h-1.25h-2.531H9.5v-4.375h1.844h2.531h1.25h2.797H19.5V19.267z
    	 M19.5,13.642h-1.938h-2.437h-1.25h-2.063H9.5V9.267h2.312h2.063h1.25h2.437H19.5V13.642z M19.5,8.017h-2.328h-2.047h-1.25h-1.422
    	H9.5V3.642h2.953h1.422h1.25h2.047H19.5V8.017z"></path>
    </svg>`;
        itemHtml += "</span></a>";
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "list", "grid") +
          '" title="' +
          buildDisplayTitle("grid", 2) +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "list", "grid") +
          '" title="' +
          buildDisplayTitle("grid", 3) +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "list", "grid") +
          '" title="' +
          buildDisplayTitle("grid", 4) +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "list", "grid") +
          '" title="' +
          buildDisplayTitle("grid", 5) +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "list", "grid") +
          '" title="' +
          buildDisplayTitle("grid", 6) +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
      } else {
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "grid", "list") +
          '" title="' +
          buildDisplayTitle("list") +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
        itemHtml +=
          '<a href="' +
          Utils.buildToolbarLink("display", "list", "grid") +
          '" title="' +
          buildDisplayTitle("grid") +
          '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
      }
    }

    itemHtml = itemHtml.replace(
      /{{class.productDisplayType}}/g,
      Class.productDisplayType
    );

    return itemHtml;
  };

  function buildDisplayTitle(type, count) {
    if (type === "") return type;
    // Build title for list view
    if (type === "list") {
      return Labels.listView || "List view";
    }
    // Build title for grid view
    if (typeof count === "undefined" || count === 0)
      return Labels.gridView || "Grid view";
    return (Labels.gridViewColumns || "Grid view {{ count }} Columns").replace(
      /{{ count }}/g,
      count
    );
  }

  var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
  ProductDisplayType.prototype.render = function () {
    // Call the original function in our app lib.
    // We don't have to copy a very big function out here to modify.
    // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
    originalRenderProductDisplayType.call(this);

    // Do your custom code after the original function has run
    // Active current display type
    if (this.$element.length) {
      this.$element
        .find(this.selector.productDisplayTypeList)
        .removeClass("active");
      this.$element
        .find(this.selector.productDisplayTypeGrid)
        .removeClass("active");
      if (Utils.stripHtml(Globals.queryParams.display) == "list") {
        this.$element
          .find(this.selector.productDisplayTypeList)
          .addClass("active");
      } else if (Utils.stripHtml(Globals.queryParams.display) == "grid") {
        this.$element
          .find(this.selector.productDisplayTypeGrid)
          .addClass("active");
      }
    }
  };

  // Build Show Limit
  ProductLimit.prototype.compileTemplate = function () {
    var html = "";
    if (
      boostPFSThemeConfig.custom.show_limit &&
      boostPFSTemplate.hasOwnProperty("showLimitHtml")
    ) {
      var numberList = Settings.getSettingValue("general.showLimitList");
      if (numberList != "") {
        // Build content
        var showLimitItemsHtml = "";
        var arr = numberList.split(",");
        for (var k in sortingArr) {
          showLimitItemsHtml +=
            '<option value="' +
            arr[k].trim() +
            '">' +
            arr[k].trim() +
            "</option>";
        }
        html = boostPFSTemplate.showLimitHtml.replace(
          /{{showLimitItems}}/g,
          showLimitItemsHtml
        );
      }
    }
    return html;
  };
  // Build Breadcrumb
  Breadcrumb.prototype.compileTemplate = function (colData) {
    if (!colData) colData = this.collectionData;
    var breadcrumbItemsHtml = "";
    if (boostPFSTemplate.hasOwnProperty("breadcrumbHtml")) {
      if (
        typeof colData !== "undefined" &&
        colData.hasOwnProperty("collection")
      ) {
        var colInfo = colData.collection;
        if (
          typeof this.collectionTags !== "undefined" &&
          this.collectionTags !== null
        ) {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink
            .replace(/{{itemLink}}/g, "/collections/" + colInfo.handle)
            .replace(/{{itemTitle}}/g, colInfo.title);
          breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
          breadcrumbItemsHtml +=
            boostPFSTemplate.breadcrumbItemSelected.replace(
              /{{itemTitle}}/g,
              this.collectionTags[0]
            );
        } else {
          breadcrumbItemsHtml +=
            boostPFSTemplate.breadcrumbItemSelected.replace(
              /{{itemTitle}}/g,
              colInfo.title
            );
        }
      } else {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(
          /{{itemTitle}}/g,
          Settings.getSettingValue("label.defaultCollectionHeader")
        );
      }
    }
    return breadcrumbItemsHtml;
  };

  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    // var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    // var localeURLPart = "";

    // if (hasShopifyRoutes) {
    //     localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    // }

    //     for (var i = 0; i < data.length; i++) {
    //       const prodId = data[i]['id'];
    //       quickUrl = localeURLPart + '/products/' + data[i].handle + '?view=boost-pfs-integration';
    //       jQ.ajax({
    //           url: quickUrl,
    //           success: function(result) {
    //               try {
    //                   var res = JSON.parse(result);
    //                  console.log(res)
    //                   jQ('[data-id="' + res.id + '"]').find('.boost-sd-availability').append(res.avaibility.trim());
    //               } catch (error) {
    //                   console.log(error);
    //               }
    //           }
    //       });
    //   }

    var displayValue = boostPFSFilterConfig.general.defaultDisplay;
    var params = new URL(location.href).searchParams;
    var display = params.get('display');
    if (Globals.queryParams.event_type == 'init' && display) {
      displayValue = display;
    }
    
    if (Globals.queryParams.event_type != 'init') {
      displayValue = Globals.queryParams.display;
    }
    
    if (displayValue == "grid" || displayValue == null) {
      jQ("#CollectionProducts").removeClass("collection-grid-list-xl");
    } else {
      jQ("#CollectionProducts").addClass("collection-grid-list-xl");
    }

    if (window.innerWidth > 767) {
      jQ(".product-collection .product-image").each(function () {
        var imageWidth = jQ(this).width();
        jQ(this).height(imageWidth);
        jQ(this).find("a").height(imageWidth);
      });

      var minHeight = jQ(
        ".collection-product-grid .col-xl-4 .product-collection"
      ).height();
      jQ(".collection-product-grid .col-xl-4 .product-collection").each(
        function () {
          if (minHeight < jQ(this).height()) {
            minHeight = jQ(this).height();
          }
        }
      );
      jQ(".collection-product-grid .col-xl-4 .product-collection").height(
        minHeight + 18
      );
    }

    jQ(
      ".product-help__link-wrapper--contact .product-help__contact-info .product-help__text--callback-main .confirm-availability-btn"
    ).on("click", function () {
      jQ(".confirm-availability .popup-delivery-confirm-availability h2").text(
        "Request Callback"
      );
      jQ("#CallbackFormName").val("Request Callback");
    });
    jQ(
      ".product-help__link-wrapper--contact .product-help__contact-info .product-help__text--desktop + .product-help__text--desktop .confirm-availability-btn"
    ).on("click", function () {
      jQ(".confirm-availability .popup-delivery-confirm-availability h2").text(
        "Contact Sparks Team Member"
      );
      jQ("#CallbackFormName").val("Confirm Availability");
    });

    jQ(".confirm-availability-btn").on("click", function () {
      var confirmTitle = jQ(this)
        .closest(".boost-root-item")
        .find(".boost-pfs-filter-product-title")
        .text();
      var confirmMSG = `I'm interested in the ` + confirmTitle + `.`;
      jQ("#ContactFormMessage").text(confirmMSG);
    });

    jQ(".product-help__contact-info .confirm-availability-btn").on(
      "click",
      function () {
        jQ("#ContactFormMessage").text("");
      }
    );

    if (jQ(".toggle .toggle-title").hasClass("active")) {
      jQ(".toggle .toggle-title.active")
        .closest(".toggle")
        .find(".toggle-inner")
        .show();
    }
    jQ(".toggle .toggle-title").click(function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (jQ(this).hasClass("active")) {
        jQ(this)
          .removeClass("active")
          .closest(".toggle")
          .find(".toggle-inner")
          .hide();
      } else {
        jQ(this)
          .addClass("active")
          .closest(".toggle")
          .find(".toggle-inner")
          .show();
      }
    });

    if (document.getElementById("ban_video") != null) {
      if (jQ("body").hasClass("template-collection")) {
        var ban_video = document.getElementById("ban_video");
        ban_video.play();
      }
    }

    jQ(".FirstBanner.banner-section button.desktop-video-mute-click-region").on(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (jQ(".FirstBanner.banner-section video").prop("muted")) {
          jQ(".FirstBanner.banner-section video").prop("muted", false);
          jQ(
            'div.FirstBanner.banner-section [data-itemid="sbv-video-mute-icon"]'
          )
            .removeClass("active")
            .addClass("unactive");
          jQ(
            'div.FirstBanner.banner-section [data-itemid="sbv-video-unmute-icon"]'
          )
            .removeClass("unactive")
            .addClass("active");
        } else {
          jQ(".FirstBanner.banner-section video").prop("muted", true);
          jQ(
            'div.FirstBanner.banner-section [data-itemid="sbv-video-mute-icon"]'
          )
            .removeClass("unactive")
            .addClass("active");
          jQ(
            'div.FirstBanner.banner-section [data-itemid="sbv-video-unmute-icon"]'
          )
            .removeClass("active")
            .addClass("unactive");
        }
      }
    );

    jQ(".custom-buy-now-button").on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      let current_id = jQ(this).attr("data-id");
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: current_id,
        },
        dataType: "json",
        success: function () {
          window.location.href = "/cart";
        },
      });
    });

    jQ(
      ".SecondBanner.banner-section button.desktop-sec-video-mute-click-region"
    ).on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      // console.log("click");
      if (jQ(".SecondBanner.banner-section video").prop("muted")) {
        jQ(".SecondBanner.banner-section video").prop("muted", false);
        jQ('.SecondBanner.banner-section [data-itemid="sbv-video-mute-icon"]')
          .removeClass("active")
          .addClass("unactive");
        jQ('.SecondBanner.banner-section [data-itemid="sbv-video-unmute-icon"]')
          .removeClass("unactive")
          .addClass("active");
        //         	console.log("if");
      } else {
        jQ(".SecondBanner.banner-section video").prop("muted", true);
        jQ('.SecondBanner.banner-section [data-itemid="sbv-video-mute-icon"]')
          .removeClass("unactive")
          .addClass("active");
        jQ('.SecondBanner.banner-section [data-itemid="sbv-video-unmute-icon"]')
          .removeClass("active")
          .addClass("unactive");
        //             console.log("else");
      }
    });

    scrollToMute();

    // Intergrate Review Shopify
    if (
      window.SPR &&
      typeof window.SPR.initDomEls == "function" &&
      typeof window.SPR.loadBadges == "function" &&
      boostPFSThemeConfig.custom.show_product_review
    ) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }

    /* start-boost-custom */
    /* #boost-118852: fix wishlist status */
    try {
      setTimeout(theme.StoreLists.checkProductStatus, 200);
    } catch (e) {
      //console.log('error loading wishlist', e);
    }

    /* #boost-118432: fix wishlist added */
    var wishlist_guest = JSON.parse(localStorage.getItem("wishlist-guest"));
    if (
      typeof wishlist_guest !== "undefined" &&
      wishlist_guest !== null &&
      wishlist_guest.length > 0
    ) {
      for (var i = 0; i < wishlist_guest.length; i++) {
        //console.log(Object.keys(wishlist_guest[i])[0]);
        jQ(
          '[data-product-variant-id="' +
          Object.keys(wishlist_guest[i])[0] +
          '"]'
        )
          .find(".js-store-lists-add-wishlist")
          .attr("data-button-status", "added");
      }
    }
    /* end-boost-custom */

    // Start Boost 161717
    if (
      boostPFSConfig.general.collection_handle == "accessories" ||
      boostPFSConfig.general.collection_id == 80421519418
    ) {
      jQ(".boost-pfs-filter-product-bottom-inner .free-delivery-part").addClass(
        "hide"
      );
      jQ(".boost-pfs-filter-product-bottom-inner .installation-part").addClass(
        "hide"
      );
    }
    // End Boost 161717

    var customButtons = document.getElementsByClassName("customChatButton");
    for (var i = 0; i < customButtons.length; i++) {
      customButtons[i].addEventListener("click", function () {
        // $zopim.livechat.window.show();
        $(".popup-chat-bot").addClass("show");
      });
    }
       
  // Initialize Slick only on screen widths below 1024px
  if ($(window).width() < 768) {
    $('.mobile-slick-slider').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  };

  // Build additional elements
  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data;
    var totalProduct =
      data.total_product +
      "<span> " +
      boostPFSThemeConfig.label.items_with_count_other +
      "</span>";
    if (data.total_product == 1) {
      totalProduct =
        data.total_product +
        "<span> " +
        boostPFSThemeConfig.label.items_with_count_one +
        "</span>";
    }
    if (data.total_product == 0) {
      jQ(".boost-pfs-filter-default-toolbar-inner").addClass(
        "boost-pfs-filter-toolbar-product-0"
      );
    } else {
      jQ(".boost-pfs-filter-default-toolbar-inner").removeClass(
        "boost-pfs-filter-toolbar-product-0"
      );
    }
    jQ(".boost-pfs-filter-total-product").html(totalProduct);

    jQ("body").find(".boost-pfs-filter-skeleton-button").remove();

    // Prevent double tap on iOS
    var isiOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isiOS) {
      Utils.isMobile() &&
        jQ(".boost-pfs-filter-product-item")
          .find("a")
          .on("touchstart", function () {
            isScrolling = !1;
          })
          .on("touchmove", function () {
            isScrolling = !0;
          })
          .on("touchend", function () {
            isScrolling || (window.location = jQ(this).attr("href"));
          });
    }

    // Build Image Swap. Put this function here to impprove the pagespeed.
    swapImage(data);

    setTimeout(function () {
      if (typeof matchHeight != "undefined") {
        $(".boost-root-item").matchHeight(); //Boost 232076
      }
    }, 1000);

    if (jQ(".boost-pfs-filter-option-value").length < 1) {
      jQ(".collections__sidebar").remove();
    }

    // Build Equal Height
    /*
      if (Utils.stripHtml(Globals.queryParams.display) !== 'list') {
        setTimeout(function(){
          equalHeight(data);
        }, 700);
      };
    
      jQ(window).resize(function() {
        if (Utils.stripHtml(Globals.queryParams.display) !== 'list') {
          setTimeout(function(){
            equalHeight(data);
          }, 700);
        }
      });
      */
    // Build Event Color Swatch
    eventColorSwatches("click", data);

    if (typeof boostRemoveImageLoadingAnimation == "function") {
      boostRemoveImageLoadingAnimation(
        jQ(Selector.products).find("[data-boost-image-loading-animation]")
      );
    }

    // Layout Fullwidth Page
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("layout_type") &&
      boostPFSThemeConfig.custom.layout_type == "fullwidth" &&
      !Utils.isMobile()
    ) {
      jQ("body").addClass("boost-pfs-filter-fullwidth-page");
    }
    document.addEventListener("scroll", function () {
      if (
        jQ(".boost-pfs-filter-tree-h.boost-pfs-filter-stick").length > 0 &&
        jQ(window).width() > 767
      ) {
        jQ(".boost-pfs-filter-custom-sorting .boost-pfs-filter-filter-dropdown")
          .hide()
          .parent()
          .removeClass("boost-pfs-filter-sort-active");
      }
    });

    // Fix confict Sticky Mobile theme Streamline
    if (jQ(".site-nav__thumb-menu").length > 0 && Utils.isMobile()) {
      var heightHeaderThemeStick = jQ(".site-nav__thumb-menu").height() + 40;
      jQ(".boost-pfs-filter-tree-mobile-button-stick-wrapper")
        .css("bottom", heightHeaderThemeStick)
        .addClass("boost-pfs-filter-sticky-bottom");
      jQ(".boost-pfs-filter-mobile-style1").addClass(
        "boost-pfs-filter-mobile-style1-sticky-bottom"
      );
    }

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const dateObj = new Date();
    const datesvar = addDays(new Date(), 3);
    const month = monthNames[dateObj.getMonth()];
    const day = String(dateObj.getDate() + 3).padStart(2, "0");
    const year = dateObj.getFullYear();
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    var GetWeekday = weekday[datesvar.getDay()];
    const output = GetWeekday + ", " + month + " " + day;
    var newOutput = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
    var res = String(newOutput).slice(0, 15);

    const startDate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000);
    const endDate = new Date(Date.now() + 9 * 24 * 60 * 60 * 1000);

    const options = { month: "short", day: "numeric" };
    const startDateFormatted = startDate.toLocaleDateString("en-US", options);
    const endDateFormatted = endDate.toLocaleDateString("en-US", options);
    const result = `${startDateFormatted} to ${endDateFormatted}`;

    jQ(".free-delivery-part #DeliveryDate").html(
      "<span>Estimated By: " + result + "</span>"
    );
    jQ(".installation-part.part .part-content-desc span.green").html(
      "<span>Estimat By: " + result + "</span>"
    );

    var wishlistBtn = jQ(".header__btn-wishlist");

    wishlistBtn.on("click", function () {
      var timer = setTimeout(function () {
        window.scrollTo(0, 0);
      }, 20);
    });
  };

  function addDays(theDate, days) {
    return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
  }

  function removeClassByPrefix(node, prefix) {
    var regx = new RegExp("\\b" + prefix + "[^ ]*[ ]?\\b", "g");
    node.className = node.className.replace(regx, "");
    return node;
  }

  ProductListPlaceholder.prototype.render = function () {
    // Set limit number for product skeleton
    var placeholderLimit =
      this.settings.productsPerRow || this.settings.placeholderProductPerRow;
    // Build placeholder items
    var placeholderItem = this.compileTemplate();
    this.$element = [];
    for (var i = 0; i < placeholderLimit; i++) {
      this.$element.push(jQ(placeholderItem));
    }
    // Show placeholder before send filter request OR hide it after get filter data
    if (!this.isFetchedProductData) {
      this.setShow();
    } else {
      this.setHide();
    }
  };

  ProductListPlaceholder.prototype.compileTemplateExtra = function () {
    //Todo: Build placeholder for List mode
    var template = boostPFSTemplate.productListPlaceholderHtml;
    var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
    var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
    /**
     * Set product class for product skeleton (to set column, style, etc.)
     * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
     */
    return template
      .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
      .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
      .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
      .replace(/{{paddingTop}}/g, imgRatio * 100);
  };

  ProductDisplayType.prototype._onClickEvent = function (event) {
    event.preventDefault();
    Globals.internalClick = true;

    // Update the active item
    var $targetEl = jQ(event.currentTarget);
    $targetEl.siblings().removeClass("active");
    $targetEl.addClass("active");
    var displayValue = Utils.stripHtml($targetEl.data("display"));
    if (displayValue) {
      FilterApi.setParam("display", displayValue);
    } else {
      var url = new URL($targetEl.attr("href"));
      displayValue = Utils.stripHtml(url.searchParams.get("display"));
      if (displayValue) {
        FilterApi.setParam("display", displayValue);
      }
    }

    if (displayValue == "grid") {
      jQ("#CollectionProducts").removeClass("collection-grid-list-xl");
    } else {
      jQ("#CollectionProducts").addClass("collection-grid-list-xl");
    }
    // Apply filter
    FilterApi.applyFilter("display");
  };

  FilterApi.beforeCall = function (eventType, eventInfo) {
    /* Change the filter params before calling api */
    if (window.innerWidth <= 1024) {
      Globals.queryParams["display"] = "list";
      if (typeof four_slot_link !== "undefined" && four_slot_link.length > 10) {
        Globals.queryParams["limit"] = 19;
      } else {
        Globals.queryParams["limit"] = 20;
      }
    }
    if (Utils.isMobile()) {
      if (typeof four_slot_link !== 'undefined' && four_slot_link.length > 10) {
        Globals.queryParams['limit'] = 13;
      } else {
        Globals.queryParams['limit'] = 14;
      }
    }
    /* No need to return anything */
    /*Boost 233384 Hide product with HideProduct tag*/
    Globals.queryParams.h_options = [];
    Globals.queryParams.h_options.push("HideProduct");
    /*End Boost 233384*/
  };

  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function (a, b) { };

  /* Math qual Height */
  function equalHeight(data) {
    var equal_i = -1;
    var equal_els = [];
    var equal_element = null;

    // Equal Height Title
    jQ(".boost-pfs-filter-product-item").each(function (i, element) {
      var offsetTop = jQ(element).offset().top;
      if (!equal_element || equal_element.offset().top !== offsetTop) {
        equal_element = jQ(element);
        equal_i++;
      }

      if (!equal_els[equal_i]) {
        equal_els[equal_i] = [];
      }
      equal_els[equal_i].push(element);
    });

    for (var i = 0; i < equal_els.length; i++) {
      var max = 0;
      var maxRatio = 0;
      var iLength = equal_els[i].length;

      for (var j = 0; j < equal_els[i].length; j++) {
        var item = equal_els[i][j];
        var height = jQ(item)
          .find(".boost-pfs-filter-product-bottom-inner")
          .height();
        max = Math.max(max, height);
      }
      jQ(equal_els[i]).find(".boost-pfs-filter-product-bottom-inner").css({
        "min-height": max,
      });
    }

    var aspect_ratio = boostPFSFilterConfig.general.aspect_ratio;

    if (aspect_ratio != "false") {
      var cropImagePosition =
        boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

      var widthImage = jQ(".boost-pfs-filter-product-item").width();
      var indexData = 0;

      // For Ratio
      if (aspect_ratio != "false" && aspect_ratio != "auto") {
        var heightImage = 0;
        var widthImage = jQ(".boost-pfs-filter-product-item").width();
        if (
          aspect_ratio != "false" &&
          aspect_ratio != "auto" &&
          aspect_ratio != "other"
        ) {
          var ratioWidthHeight = boostPFSThemeConfig.custom.aspect_ratio;
        } else {
          var ratioWidthHeight = "";
        }

        var ratioWidthHeightOther =
          boostPFSThemeConfig.custom.aspect_ratio_other;
        if (ratioWidthHeightOther == "" && ratioWidthHeight == "") {
          return null;
        } else {
          if (aspect_ratio != "other") {
            ratioWidthHeight = ratioWidthHeight.split(":");
            ratioWidthHeight =
              parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
            heightImage = widthImage * ratioWidthHeight;
          } else if (ratioWidthHeightOther != "" && aspect_ratio == "other") {
            ratioWidthHeightOther = ratioWidthHeightOther.split(":");
            ratioWidthHeightOther =
              parseInt(ratioWidthHeightOther[1]) /
              parseInt(ratioWidthHeightOther[0]);
            heightImage = widthImage * ratioWidthHeightOther;
          }
        }
        jQ(".boost-pfs-filter-product-item-image-link")
          .css({
            "padding-top": heightImage + "px",
          })
          .addClass(
            "boost-pfs-filter-crop-image-position-" + cropImagePosition
          );
      }
    }
  }

  // Swap Image
  function swapImage(data) {
    var imageArray = [];
    $.each(data.products, function (key, value) {
      var media = value.media[1];
      if (value.media[1] == undefined) {
        media = value.media[0];
      }
      imageArray.push(media);
    });
    if (!Utils.isMobile()) {
      //if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
      //boostPFSThemeConfig.custom.active_image_swap == true) {
      var dataSrcSetFlipImg = "",
        dataSrcFlipImg = "",
        flipImageAlt = "",
        dataSizes = "auto",
        dataWidths = "",
        html = "";

      jQ(".product-collection__wrapper").each(function (
        key,
        value
      ) {
        var productItemSelector = jQ(this);
        var imgSelector = productItemSelector.find(
          ".boost-pfs-filter-product-item-main-image"
        );
        // var videoSelector = productItemSelector.attr('data-json-product');
        // var productData = JSON.parse(videoSelector);

        // if (imageArray[key] && imageArray[key].mediaContentType && imageArray[key].mediaContentType === 'EXTERNAL_VIDEO') {
        //     console.log('EXTERNAL_VIDEO');
        //     var videoURL = imageArray[key].embeddedUrl;
        //     var arr = videoURL.split('/');
        //     var autoplay = 0;

        //     productItemSelector.find(".product-collection .product-image a").mouseenter(function() {
        //         productItemSelector.find('.entermouse').remove();
        //         autoplay = '1';
        //         var IframeURL = 'https://www.youtube.com/embed/' + arr[3] + '?mute=1&control=0&autoplay=' + autoplay + '';
        //         html = '<iframe class="entermouse" src="' + IframeURL + '"></iframe>';
        //         productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
        //     });
        //     productItemSelector.find(".product-collection .product-image a").mouseleave(function() {
        //         productItemSelector.find('.entermouse').remove();
        //         autoplay = '0';
        //         var IframeURL = 'https://www.youtube.com/embed/' + arr[3] + '?mute=1&control=0&autoplay=' + autoplay + '';
        //         html = '<iframe class="entermouse" src="' + IframeURL + '"></iframe>';
        //         productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
        //     });
        //     // html = '<iframe src="https://www.youtube.com/embed/'+  arr[3] +'?mute=1&control"></iframe>';
        //     // productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
        //     console.log('true');
        // }
        if (
          imageArray[key] &&
          imageArray[key].mediaContentType &&
          imageArray[key].mediaContentType === "VIDEO"
        ) {
          jQ(this).addClass("exit-video");
          var MP4videoURL = "";
          var MP4videoURLArray = imageArray[key].sources;
          jQ.each(MP4videoURLArray, function (key, value) {
            if (value.url.indexOf(".mp4") != -1) {
              MP4videoURL = value.url;
              return false;
            }
          });

          if (key == 2) {
            productItemSelector.find(".MP4video").remove();
            html =
              '<video class="MP4video" width="100%" height="auto" muted loop playsinline muted autoplay="false" controlslist="nodownload" disablepictureinpicture>' +
              '<source src="' +
              MP4videoURL +
              '" type="video/mp4">' +
              '<source src="' +
              MP4videoURL +
              '" type="video/ogg">' +
              "</video>";
            productItemSelector
              .find(".boost-pfs-filter-product-item-image-link")
              .append(html);
          }

          productItemSelector
            .find(".product-collection .product-image a")
            .mouseenter(function () {
              productItemSelector.find(".MP4video").remove();
              html =
                '<video class="MP4video" width="100%" height="auto" muted loop playsinline muted autoplay="true" controlslist="nodownload" disablepictureinpicture>' +
                '<source src="' +
                MP4videoURL +
                '" type="video/mp4">' +
                '<source src="' +
                MP4videoURL +
                '" type="video/ogg">' +
                "</video>";
              productItemSelector
                .find(".boost-pfs-filter-product-item-image-link")
                .append(html);
            });

          productItemSelector
            .find(".product-collection .product-image a")
            .mouseleave(function () {
              productItemSelector.find(".MP4video").remove();
              html =
                '<video class="MP4video" width="100%" height="auto" loop playsinline muted autoplay="false" controlslist="nodownload" disablepictureinpicture>' +
                '<source src="' +
                MP4videoURL +
                '" type="video/mp4">' +
                '<source src="' +
                MP4videoURL +
                '" type="video/ogg">' +
                "</video>";
              productItemSelector
                .find(".boost-pfs-filter-product-item-image-link")
                .append(html);
            });
        } else {
          if (
            typeof imgSelector.data("img-flip-src") != "undefined" &&
            imgSelector.data("img-flip-src") != ""
          ) {
            dataSrcFlipImg = imgSelector.data("img-flip-src");
            dataSrcSetFlipImg = imgSelector.data("img-flip-srcset");
            flipImageAlt = imgSelector.attr("alt");
            dataWidths = imgSelector.data("widths");
            html =
              '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
              'data-srcset="' +
              dataSrcSetFlipImg +
              '" ' +
              'data-src="' +
              dataSrcFlipImg +
              '" ' +
              'data-widths="[' +
              dataWidths +
              ']" ' +
              'data-sizes="' +
              dataSizes +
              '" ' +
              'src="' +
              boostPFSImgDefaultSrc +
              '" ' +
              'alt="' +
              flipImageAlt +
              '" />';

            productItemSelector
              .find(".boost-pfs-filter-product-item-image-link")
              .append(html);
          }
        }
      });
      //}
    }
  }

  function scrollToMute() {
    jQ(window).on("scroll", function () {
      if (
        typeof jQ("#shopify-section-First-Banner-collection").offset() !==
        "undefined"
      ) {
        var top_of_element = jQ(
          "#shopify-section-First-Banner-collection"
        ).offset().top;
        var bottom_of_element =
          jQ("#shopify-section-First-Banner-collection").offset().top +
          jQ("#shopify-section-First-Banner-collection").outerHeight();
        var bottom_of_screen = window.pageYOffset + jQ(window).innerHeight();
        var top_of_screen = window.pageYOffset;
        var ban_video = document.getElementById(
          "shopify-section-First-Banner-collection"
        );

        if (
          bottom_of_screen > top_of_element &&
          top_of_screen < bottom_of_element
        ) {
        } else {
          jQ("#shopify-section-First-Banner-collection video").prop(
            "muted",
            true
          );
          jQ(
            '#shopify-section-First-Banner-collection [data-itemid="sbv-video-mute-icon"]'
          )
            .removeClass("unactive")
            .addClass("active");
          jQ(
            '#shopify-section-First-Banner-collection [data-itemid="sbv-video-unmute-icon"]'
          )
            .removeClass("active")
            .addClass("unactive");
        }
      }
    });
  }

  // Build Placeholder for the first load
  function boostRemoveImageLoadingAnimation($selector) {
    if ($selector.length) {
      $selector.removeAttr("data-boost-image-loading-animation");
    }
  }

  /* Expand Filter */
  jQ(document).ready(function () {
    jQ(".boost-pfs-filter-custom-filter-button").on("click", function () {
      jQ("body").toggleClass("boost-pfs-filter-custom-drawer-open");
    });
    jQ(".boost-pfs-filter-custom-drawer-close").click(function () {
      jQ("body").removeClass("boost-pfs-filter-custom-drawer-open");
    });
    jQ(".boost-pfs-filter-custom-drawer-overlay").click(function () {
      jQ("body").removeClass("boost-pfs-filter-custom-drawer-open");
    });

    // Bind changing options with enter/space key for ADA
    jQ(
      ".boost-pfs-filter-custom-drawer-close, .boost-pfs-filter-custom-drawer-overlay"
    ).on("keydown", (event) => {
      if (event.target && (event.keyCode == 13 || event.keyCode == 32)) {
        jQ(event.target).click();
      }
    });

    // Fix issue header fix on the Parallax theme
    if (jQ(".mm-fixed-top").length > 0) {
      var headerFixedHeight = jQ(".mm-fixed-top").height();
      jQ(".boost-pfs-filter-collection-header-wrapper").css(
        "margin-top",
        headerFixedHeight
      );
    }
  });
})();
